/* eslint-disable max-len */

export default {
  errors: {
    global: {
      internal: 'Error interno',
      not_allowed: 'Acción no permitida',
      access_denied: 'Acceso denegado',
      validator_error: 'Error del validación {details}',
      wrong_body: 'Wrong body',
      wrong_token: 'Token incorrecto',
      missing_token: 'Token no encontrado',
      exclusive_lock: 'Exclusive lock',
      access_denied_acl: 'Acceso denegado (ACL)',
      connection_timeout: 'Tiempo de espera agotado',
      login_required: 'Inicio de sesión requerido',
      not_found: 'No encontrado',
      wrong_value: 'Valor incorrecto',
      token_expired: 'Token expirado',
      service_not_available: 'Servicio no disponible',
      twofa_required: 'Se requiere autenticación 2FA',
      missing_login_token: 'Inicio de sesión requerido',
    },
    account: {
      banned: 'Cuenta suspendida',
      wrong_login_or_password: 'Nombre de usuario o contraseña incorrectos',
      wrong_login: 'Inicio de sesión incorrecto',
      wrong_password: 'Contraseña incorrecta',
      blocked: 'Cuenta bloqueada',
      missing_email: 'Dirección de correo electrónico no asignada',
      same_password_used: 'Se ha utilizado la misma contraseña',
      apikey_not_created: 'Clave API no creada',
      apikey_already_created: 'Clave API ya creada',
      twofa_not_created: '2FA no creado',
      twofa_already_created: '2FA creado',
      deletion_already_started: 'La eliminación de la cuenta ha comenzado',
      wrong_twofa: 'Código 2FA incorrecto',
      external_withdraw_not_available: 'La retirada externa no está disponible',
      twofa_limit: '2FA limitado',
      kyc_wrong_step: 'KYC paso incorrecto',
      not_exists: 'Inexistente',
      kyc_required: 'Se requiere KYC',
      action_not_allowed: 'Acción no permitida',
      migration: 'Migración',
      wrong_password_pattern: 'La contraseña debe tener de 8 a 64 caracteres y al menos uno que sea: mayúscula, minúscula, número o un carácter especial',
    },
    market: {
      not_enough_funds: 'No hay suficientes fondos',
      missing_steam_token: 'Falta la url de intercambio de Steam',
      missing_steam_id: 'Falta el ID de Steam',
      wrong_item_status: 'Wrong item status',
      item_already_queued: 'Artículo ya en cola',
      max_price_limit: 'Precio máximo',
      item_not_available: 'Artículo no disponible',
      steam_vac_ban: 'Suspensión Steam VAC ',
      steam_trade_ban: 'Suspensión en comercio de Steam',
      steam_private_profile: 'Perfil privado en Steam',
      steam_private_inventory: 'Inventario privado en Steam',
      steam_tradehold: 'Retención de artículo en Steam',
      cannot_check_tradeban: 'No se puede comprobar la suspensión de comercio',
      cannot_check_tradehold: 'No se puede comprobar la retención del artículo',
      wrong_steam_token: 'Token equivocado de Steam',
      no_items_found: 'No se han encontrado artículos',
      items_limit: 'Límite de artículos',
      instant_sell_disabled: 'Venta instantánea desactivada',
      plan_not_found: 'Plan no encontrado',
      price_too_low: 'Precio demasiado bajo',
      queue_full: 'La cola para retirar está llena, inténtelo de nuevo más tarde. ',
    },
    steam: {
      wrong_tradelink: 'Enlace de comercio incorrecto',
      private_inventory: 'Inventario privado de Steam',
      cannot_check_tradeban: 'No podemos comprobar la suspensión en el comercio',
      cannot_check_tradehold: 'No podemos comprobar la retención comercial',
      vac_ban: 'Suspensión VAC',
      trade_ban: 'Suspensión del comercio',
      private_profile: 'Perfil privado de Steam',
      tradehold: 'Comercio retenido',
      wrong_token: 'Token incorrecto',
      missing_token: 'Falta la url de comercio de Steam',
      missing_steam_id: 'Falta la ID de Steam',
      community_ban: 'Suspensión comunitaria',
      economy_ban: 'Suspensión económica',
      platform_offline: 'No se ha podido establecer una conexión con Steam, sus servidores pueden estar inactivos. Pruebe de nuevo más tarde.',
      cannot_check_escrow: 'No se puede comprobar el depósito',
      escrow: 'Estás utilizando Steam Guard por correo electrónico, lo cual no es suficiente para comerciar con nuestros bots. Tienes que activar Steam Guard móvil para poder operar con nuestros bots.',
      fresh_account: 'Primero tienes que configurar el perfil de steam',
    },
    mutex: {
      long_lock: 'Bloqueo prolongado, inténtalo de nuevo en {ttl} segundos',
      exclusive_lock: 'Cerradura exclusiva',
    },
    api: {
      missing_apikey: 'Falta la clave API',
      missing_secret: 'Falta la API secreta',
      wrong_ip_address: 'Dirección IP incorrecta',
      private_ip_address: 'Dirección IP privada',
      wrong_apikey: 'Apikey equivocada',
    },
    record: {
      item_not_found: 'Artículo no encontrado',
      item_not_owned: 'Artículo no poseído',
      own_item: 'Artículo propio',
      there_are_no_records: 'No hay registros para mostrar',
      record_already_exists: 'El registro ya existe',
      record_not_exists: 'El registro no existe',
      already_exists: 'Ya existe',
      not_exists: 'No existe',
      not_updated: 'No actualizado',
      forbidden: 'Prohibido',
    },
    bot: {
      not_found: 'Bot no encontrado',
      not_available: 'Bot no disponible',
    },
    wallet: {
      cannot_transfer_money: 'No se puede transferir dinero',
      amount_negative: 'Importe negativo',
      amount_positive: 'Importe positivo',
      card_scoring_too_low: 'Puntuación de la tarjeta demasiado baja',
      not_enough_balance: 'Saldo insuficiente',
      kyc_window_limit: 'Límite en KYC',
      service_window_limit: 'Límite en la ventana de servicio',
      amount_limit: 'Cantidad límite ',
      wrong_wallet_address: 'Dirección del monedero incorrecta',
      card_not_found: 'Tarjeta no encontrada',
      cannot_process_transaction: 'No podemos procesar tu transacción',
      only_past_months_accepted: 'Sólo se aceptan los meses anteriores',
      only_visa_allowed: 'Sólo se admiten tarjetas VISA',
      you_cannot_complete_this_action: 'No puedes completar esta acción porque no tienes el saldo suficiente en tu cuenta.',
      you_need_to_deposit_at_least_x: 'Necesitas depositar al menos {x} para completar esta acción.',
    },
    gift_code: {
      not_found: 'Código no encontrado',
      already_used: 'Código ya utilizado',
      own_code: 'Este es tu propio código',
    },
    partner: {
      subaccount_not_enabled: 'Subcuenta no habilitada',
      link_account_first: 'Vincular cuenta primero',
      account_already_linked: 'Cuenta ya vinculada',
      wrong_phrase: 'Frase incorrecta',
      cannot_link_yourself: 'No puedes enlazarte a ti mismo',
      account_already_exists: 'La cuenta ya existe',
    },
    payment: {
      card_scoring: 'La puntuación de la tarjeta es demasiado baja',
      payment_issue: 'Problema de pago',
    },
    auth: {
      failed_to_authenticate: 'No se ha podido autentificar',
      not_valid_identity: 'Identidad no válida',
      authentication_failed: 'Autenticación fallida',
    },
    social: {
      cannot_create_chat: 'No se puede crear chat',
    },
    support: {
      wrong_status: 'Estado incorrecto',
      ticket_limit: 'Límite de solicitudes',
    },
    ipn: {
      verification_issue: 'Problema de verificación',
    },
    affiliate: {
      same_code: 'Mismo código',
      code_taken: 'Este código ya está en uso',
      not_activated: 'No activado',
      not_enough_balance: 'Saldo insuficiente',
    },
    bam: {
      bam_steam_015: 'Nuestros bots no han podido conectarse con Steam. Por favor inténtelo de nuevo en unos minutos.',
    },
  },
  validator: {
    required: 'Esta información es obligatoria.',
    string: 'This field must be a string.',
    stringEmpty: 'Este campo no debe estar vacío.',
    stringMin: 'La longitud de este campo debe ser de al menos {expected}.',
    stringMax: 'La longitud de este campo debe tener como máximo {expected}.',
    stringLength: 'La longitud de este campo debe ser de {expected}.',
    stringPattern: 'Este campo no coincide con el patrón requerido.',
    stringPatternLatin: 'Utiliza sólo caracteres latinos.',
    stringContains: 'Este campo debe contener el texto \'{expected}\'.',
    stringEnum: 'Este campo no coincide con ninguno de los valores permitidos.',
    stringNumeric: 'Este campo debe ser una cadena numérica.',
    stringAlpha: 'Este campo debe ser una cadena alfabética.',
    stringAlphanum: 'Este campo debe ser una cadena alfanumérica.',
    stringAlphadash: 'Este campo debe ser una cadena alfanumérica.',
    stringHex: 'Este campo debe ser una cadena hexadecimal.',
    stringSingleLine: 'Este campo debe ser una cadena de una sola línea.',
    stringBase64: 'Este campo debe ser una cadena base64.',
    number: 'Este campo debe ser un número.',
    numberMin: 'Este campo debe ser mayor o igual que {expected}.',
    numberMax: 'Este campo debe ser menor o igual que {expected}.',
    numberEqual: 'Este campo debe ser igual a {expected}.',
    numberNotEqual: 'Este campo no puede ser igual a {expected}.',
    numberInteger: 'Este campo debe ser un número entero.',
    numberPositive: 'Este campo debe ser un número positivo.',
    numberNegative: 'Este campo debe ser un número negativo.',
    array: 'Este campo debe ser una matriz.',
    arrayEmpty: 'Este campo no debe ser una matriz vacía.',
    arrayMin: 'Este campo debe contener al menos {expected}.',
    arrayMax: 'Este campo debe contener menos o igual que {expected}.',
    arrayLength: 'Este campo debe contener elementos {expected}.',
    arrayContains: 'Este campo debe contener el elemento "{expected}".',
    arrayUnique: 'El valor \'{actual}\' no es único para los valores \'{expected}\'".',
    arrayEnum: 'El valor \'{actual}\' no coincide con ninguno de los valores \'{expected}\'.',
    tuple: 'Este campo debe ser una matriz.',
    tupleEmpty: 'Este campo no debe ser una matriz vacía.',
    tupleLength: 'Este campo debe contener elementos {expected}.',
    boolean: 'Este campo debe ser un booleano.',
    currency: 'Este campo debe tener un formato de moneda válido',
    date: 'Este campo debe ser una Fecha.',
    dateMin: 'Este campo debe ser mayor o igual que {expected}.',
    dateMax: 'Este campo debe ser menor o igual que {expected}.',
    enumValue: 'El valor de este campo \'{expected}\' no coincide con ninguno de los valores permitidos.',
    equalValue: 'El valor de este campo debe ser igual a "{expected}".',
    equalField: 'Este valor de campo debe ser igual al valor de campo \'{expected}\'.',
    forbidden: 'Este campo está prohibido.',
    function: 'Este campo debe ser una función.',
    email: 'Este campo debe ser un correo electrónico válido.',
    emailEmpty: 'Este campo no debe estar vacío.',
    emailMin: 'La longitud de este campo debe ser de al menos {expected}.',
    emailMax: 'La longitud de este campo debe tener como máximo {expected}.',
    luhn: 'Este campo debe ser una suma de comprobación luhn válida.',
    mac: 'Este campo debe ser una dirección MAC válida.',
    object: 'Este campo debe ser un Objeto.',
    objectStrict: 'Este objeto contiene claves prohibidas: \'{actual}\'.',
    objectMinProps: 'Este objeto debe contener al menos {expected}.',
    objectMaxProps: 'Este objeto debe contener como máximo {expected}.',
    url: 'Este campo debe ser una URL válida.',
    urlEmpty: 'Este campo no debe estar vacío.',
    uuid: 'Este campo no tiene formato de código válido.',
    uuidVersion: 'Este campo debe ser una versión UUID válida proporcionada.',
    classInstanceOf: 'Este campo debe ser una instancia de la clase \'{expected}\'.',
    objectID: 'Este campo debe ser un ObjectID válido',
    record: 'Este campo debe ser un Objeto.',
  },
  body: {
    language: 'Idioma',
    currency: 'Moneda',
    currency_warning: 'Todas las operaciones se realizan en dólares estadounidenses, las monedas distintas del USD se convierten a partir del USD y sólo cambian la forma en que se visualiza la página. Las variaciones del tipo de cambio pueden aumentar o disminuir tu saldo.',
    choose_game: 'Elige el juego',
    slider: {
      title_1: 'Actualiza tu estilo,',
      title_2: 'domina el juego',
      content_1: 'Descubre la colección definitiva de skins',
      content_2: 'Para aumentar tu experiencia de juego.',
      tile_1: 'Maximiza tu experiencia de juego',
      tile_2: 'Consigue el mejor valor por tu dinero',
      tile_3: 'Disfruta de una negociación segura y sin problemas',
    },
    footer_description: 'En BitSkins, nos hemos dedicado a proporcionar una plataforma segura para que los jugadores compren y vendan artículos de juegos populares como CS2, Dota 2, Rust y TF2. Desde nuestro lanzamiento en 2015, hemos servido con éxito a millones de clientes satisfechos, y nuestro compromiso con la seguridad sigue siendo más fuerte que nunca.',
    footer_disclaimer: '© 2015 - {year} BitSkins. Impulsado por Steam. No afiliado a Valve Corp.',
    footer_email_support: 'Si necesitas ayuda',
    footer_email_security: 'Si quieres informar de errores',
    footer_email_partnership: 'Si quieres cooperar',
    market: 'Mercado',
    cart: 'Cesta de la compra',
    cart_empty: 'Tu cesta está vacía',
    clear_cart: 'Limpiar cesta',
    checkout: 'Pago',
    in_the_cart: 'en el carro',
    total: 'Total',
    go_to_market: 'Ir al mercado',
    trustpilot_alt: 'Trustpilot con {stars} estrellas y {reviews} opiniones',
    reload_website: '¡Recarga el sitio web!',
    app_error: 'Error de aplicación: {error}',
    latest_articles: 'Últimos artículos',
    steam_login: 'Inicio de sesión en Steam',
  },
  maintenance: {
    we_will_be_back_soon: 'Volveremos pronto',
    we_are_down_for_maintenance: 'Estamos fuera de servicio por mantenimiento, pero volveremos a estar en línea en breve.',
    sorry_for_the_inconvenience: 'Disculpa las molestias y ¡Hasta pronto!',
  },
  account: {
    email: {
      required: 'Dirección de correo electrónico obligatorio',
      required_for_this_payment_method: 'No puedes utilizar este método de pago porque no has configurado tu dirección de correo electrónico.',
      you_can_start_now: 'Ya puedes iniciar el proceso de configuración.',
      setup: 'Configurar correo electrónico',
    },
    add_funds: 'Añadir fondos',
    my_store: 'Mi tienda',
    selling: 'Vender',
    transactions: 'Transacciones',
    settings: 'Ajustes',
    steam_settings: {
      open_settings: 'Abrir ajustes',
      open_steam_settings: 'Abrir perfil de Steam',
      what_is_steam_guard: '¿Qué es Steam Guard?',
      inventory_status: 'Estado del inventario',
      profile_status: 'Estado del perfil',
      change_trade_link: 'Cambiar el enlace de intercambio.',
    },
    logout: 'Cerrar sesión',
    inventory: 'Inventario',
    banned: {
      you_are_banned: 'Estás <span class="text-cr">bloqueado</span>',
      your_account_has_been_banned: 'Tu cuenta ha sido bloqueada por violar nuestros',
      your_account_has_been_blocked: 'Tu cuenta ha sido bloqueada por infringir nuestras',
      if_you_believe: 'Si crees que ha sido un error, puedes ponerte en contacto con nosotros en <span class="text-cp">support{\'@\'}bitskins.com</span>.',
      terms_of_use: 'Condiciones de uso',
    },
    account_blocked: 'Cuenta <span class="text-cr">bloqueada</span>',
    api_access: 'Acceso a la API',
  },
  balance: {
    wallet: 'Cartera',
    withdraw: 'Retirar',
    withdraw_to: 'Retirar a',
    withdraw_again: 'Retirar de nuevo',
    withdrawable: 'Retirable',
    total: 'Total',
    balance: 'Saldo',
    deposits_and_sales: 'Depósitos y ventas',
    proceeds_from_sales: 'Ingresos por ventas',
    deposit: 'Depósito',
    locked: 'Bloqueado',
    funds_locked: 'Fondos bloqueados en transacciones',
    pending_withdrawals: 'Retiradas pendientes',
    thank_you_for_your_payment: 'Gracias por tu pago',
    your_money_will_arrive_soon: 'Tu dinero llegará pronto',
    your_payment_is_still_processing: 'Tu pago aún se está procesando, pero los fondos deberían aparecer en tu cuenta en breve.',
    in_case_you_do_not_receive: 'En caso de que no recibas tus fondos en 15 minutos, ponte en contacto con nuestro servicio de asistencia.',
    payment_pending: 'Pago <span class="text-cbs">pendiente</span>',
    payment_failed: 'Pago <span class="text-cr">fracasado</span>',
    payment_canceled: 'Pago <span class="text-cg">cancelado</span>',
    payment_has_been_cancelled: 'El pago ha sido cancelado tal y como se solicitó',
    unfortunately_we_were_unable: 'Lamentablemente, no hemos podido procesar tu pago.',
    please_try_again: 'Por favor, inténtalo de nuevo',
    if_the_problem_persists: 'Si el problema persiste, ponte en contacto con nuestro servicio de asistencia. También puedes intentar utilizar un método de pago diferente.',
    back_to_wallet: 'Volver a la cartera',
    total_description: 'Los fondos procedentes de tus depósitos y ventas.',
    withdrawable_description: 'El producto de las ventas. Estos fondos pueden retirarse o gastarse en la compra de artículos.',
    locked_description: 'Fondos bloqueados temporalmente que no se pueden gastar ni retirar. La razón por la que los fondos están bloqueados se debe a pedidos de compra existentes, compra de artículos, etc.',
    deposit_with_cryptocurrencies: 'Deposita con <span class="text-cp">criptomonedas:</span>',
    deposit_with_standard_payment_methods: 'Deposita con <span class="text-cp">métodos de pago estándar:</span>',
    withdraw_with_cryptocurrencies: 'Retirar con <span class="text-cp">criptomonedas:</span>',
    withdraw_with_standard_payment_methods: 'Retirar con <span class="text-cp">métodos de pago estándar:</span>',
    your_amount: 'Tu importe',
    your_limit: 'Tu límite',
    your_limits: 'Tus límites',
    increase_your_limits: 'Aumenta tus límites',
    payment_not_available_in_the_following_countries: 'Este método de pago no está disponible en los siguientes países:',
    the_price_is_updated_every_60_seconds: 'El precio se actualiza cada 60 segundos y es el precio medio recogido de varias bolsas.',
    rate_includes_x_fee: 'La tarifa incluye el {x}% de comisión.',
  },
  not_found: {
    title: 'Página no encontrada',
    message: 'Parece que te has perdido. Puedes encontrar las skins de tus<br> sueños en la página del mercado.',
  },
  login: {
    welcome_to_bitskins: '<span class="text-cp">Bienvenido</span> a BitSkins',
    sign_in: 'Inicia sesión',
    sign_up: 'Inscríbete',
    rules_text: 'Confirmo que tengo 18 años o más y acepto la',
    sign_in_with_steam: 'Iniciar sesión con Steam',
    sign_up_with_steam: 'Regístrate con Steam',
    email: 'Correo electrónico',
    password: 'Contraseña',
    already_have_an_account: '¿Ya tienes una cuenta? Haz clic en',
    to_login: 'a el inicio de sesión',
    to_login_via_email: 'iniciar sesión por correo electrónico',
    login_via_email: 'Iniciar sesión por correo electrónico',
    log_in_using_your_email: 'Conéctate utilizando tu dirección de correo electrónico y tu contraseña.',
    forgot_password: '¿Has olvidado la contraseña?',
    login_via_steam: 'INICIAR SESIÓN A TRAVÉS DE STEAM',
    register_first: 'Primero tienes que registrarte',
    passwords_not_migrated: 'Lamentablemente, durante la reciente actualización no hemos podido migrar tu contraseña, por lo que tendrás que restablecerla.',
  },
  common: {
    monthly: 'mensualmente',
    x_to_y: '{x} a {y}',
    minimum_x: 'Mínimo {x}',
    maximum_x: 'Máximo {x}',
    click: 'Haz clic en',
    claim: 'Reclama',
    or: 'o',
    and: 'y',
    confirm: 'Confirma',
    continue: 'Continúa en',
    cancel: 'Cancelar',
    enable: 'Activa',
    enabled: 'activado',
    disable: 'Desactiva',
    disabled: 'desactivado',
    download: 'Descarga',
    twofa: 'Autenticación de dos factores',
    terms_of_use: 'Condiciones de uso',
    privacy_policy: 'Política de privacidad',
    cookie_policy: 'Política de cookies',
    about_us: 'Sobre nosotros',
    changelog: 'Registro de cambios',
    faq: 'PREGUNTAS FRECUENTES',
    support: 'Asistencia',
    affiliate: 'Afiliados',
    blog: 'Blog',
    careers: 'Empleo',
    api: 'API',
    service_status: 'Estado del servicio',
    loading: 'Cargando...',
    buy_skins: 'Comprar skins',
    sell_skins: 'Vender skins',
    popular: 'Popular',
    skin_categories: 'categorías de skins',
    payments: 'Pagos',
    about_bitskins: 'Acerca de BitSkins',
    social_media: 'Redes sociales',
    follow_us: '¡Síguenos y únete a nuestra comunidad!',
    enter_your_email: 'Introduce tu dirección de correo electrónico',
    phone_number: 'Número de teléfono',
    verify: 'Verifica',
    add: 'Añade',
    update: 'Actualiza',
    check_spam_folder: 'Si no encuentras el correo electrónico en tu bandeja de entrada, comprueba tu carpeta de correo no deseado.',
    here: 'aquí',
    edit: 'edita',
    save: 'guarda',
    copy: 'copia',
    back: 'Volver',
    back_to_login: 'Volver al inicio de sesión',
    clear: 'Limpiar',
    quantity: 'Cantidad',
    name: 'Nombre',
    bot_name: 'Nombre del bot',
    steam: 'Steam',
    steam_id: 'ID de Steam',
    steam_group: 'Grupo de Steam',
    browser: 'Navegador',
    on: 'Activado',
    off: 'Desactivado',
    hidden: 'Oculto',
    empty: 'Vacío',
    expires_in: 'Caduca en',
    member_since: 'Miembro desde',
    close: 'Cerrar',
    paint_seed_value: 'Semilla del acabado: {value}',
    error: 'Error',
    retry: 'Reintentar',
    no_options_available: 'No hay opciones disponibles',
    search: 'Buscar',
    any: 'Cualquiera',
    min: 'Mínimo ',
    max: 'Máximo',
    no_limit: 'Límite inexistente ',
    scroll_left: 'Desliza a la izquierda',
    scroll_right: 'Desliza a la derecha',
    load: 'Carga',
    delete: 'Borra',
    remove: 'Elimina',
    all: 'Todos',
    game: 'Juego',
    reset: 'Reinicia ',
    in: 'en',
    optional: '(opcional)',
    default: 'Por defecto',
    filter: 'Filtrar',
    up_to: 'Hasta',
    similar: 'Similar',
    important: 'Importante',
    step: 'Paso',
    share_link: 'Compartir enlace',
    zoom: 'Zoom',
    found: 'Encontrado',
    try_again: 'Inténtalo de nuevo',
    of: 'de',
    timer: 'Temporizador',
    add_new: 'Añadir nuevo',
    and_more: 'Y MÁS',
    check_status: 'Comprobar estado',
    resend_link: 'Reenviar enlace',
    back_to_home: 'Volver a la página de inicio',
    data_visible_only_to_logged_in_users: 'Estos datos sólo son visibles para los usuarios registrados',
    login: 'Iniciar sesión',
    level: 'Nivel',
    twofa_code: 'Código 2FA',
    id: 'ID',
    position: 'Posición',
    amount: 'Importe',
    progressive_sum: 'Suma progresiva',
    date: 'Fecha',
    active: 'Activo',
    yes: 'SI',
    no: 'NO',
  },
  notifications: {
    change: 'Cambia',
    setup: 'Configurar',
    disconnect: 'Desconecta',
    connect: 'Conecta',
    notifications: 'Notificaciones',
    notifications_center: 'Centro de notificaciones',
    clear_all: 'Borrar todas las notificaciones',
    notifications_channels: 'Canales de notificación',
    connected: 'Conectado',
    all_notifications: 'Todas las notificaciones',
    sound: 'Sonido',
    volume_mute: 'Silenciar el volumen',
    volume_full: 'Volumen al máximo',
    all_sounds: 'Todos los sonidos:',
    off: 'Desactivado',
    on: 'Activado',
    steam_issues_title: 'Problemas con Steam',
    steam_issues_content: 'Steam está experimentando problemas que pueden afectar a las operaciones, provocando que no se procesen o creen.',
    name: {
      account_new_login: 'Nuevo acceso a la cuenta',
      inventory_sold: 'Venta de inventario',
      inventory_buyorder: 'Orden de compra en inventario',
      wallet_deposit_done: 'Depósito en cartera realizado',
      support_new_reply: 'Nueva respuesta del soporte',
      support_ticket_closed: 'Ticket de soporte cerrado',
      inventory_bargain_received: 'Contraoferta recibida',
    },
  },
  market: {
    non_scraped_only: 'Sólo no raspado',
    set_price: 'Definir un precio',
    game_not_found: 'Juego no encontrado',
    game_not_available: 'Juego no disponible actualmente',
    any_stickers: 'Cualquier pegatina',
    item_removed_from_sale: 'Artículo retirado de la venta',
    price_updated: 'Precio actualizado',
    item_withdrawn: 'Este artículo ha sido retirado',
    go_to_withdrawn: 'Ir a los artículos retirados',
    item_issue: 'Tenemos problemas con este artículo',
    item_in_deposit_queue: 'Este artículo está en la cola de depósito',
    item_in_withdraw_queue: 'Este artículo está en la cola de retirada',
    go_to_queued: 'Ir a los elementos en cola',
    item_in_bitskins_inventory: 'Este artículo está en tu inventario de BitSkins',
    go_to_inventory: 'Ir al inventario',
    go_to_issue: 'Ir a problemas',
    maximum_price: 'Precio máximo',
    minimum_price: 'Precio mínimo',
    average_price: 'Precio medio',
    amount_sold: 'Cantidad vendida',
    withdrawal_batch_info: 'Ten en cuenta que enviamos artículos por lotes cada pocos minutos.',
    queued: 'En cola',
    queued_description: 'Aquí puedes encontrar elementos que están en cola para una retirada o ingreso.',
    withdrawn: 'Retirada',
    withdrawn_description: 'Aquí puedes encontrar artículos que han sido retirados.',
    issues: 'Cuestiones',
    issues_description: 'Aquí puedes encontrar los artículos con los que tenemos problemas. Estamos trabajando para resolverlo.',
    max_items_selected: 'No puedes seleccionar más de {limit} elementos',
    item_status: 'Estado del artículo',
    search_for_stickers: 'Buscar pegatinas',
    this_item: '(este artículo)',
    no_items_found: {
      no_items_found: 'No se han encontrado artículos',
      no_items_found_span: 'Ningún elemento <span>encontrado</span>',
      we_could_not_find_any_offers: 'No hemos encontrado ninguna oferta',
      for: ' para',
      this_can_be_due_to_applied_filters: 'Esto puede deberse a los filtros aplicados. Puedes borrar todos los filtros haciendo clic en el botón inferior',
    },
    only_tradable_items: 'Sólo artículos comercializables',
    not_accepting: 'No aceptando',
    sell: 'Vender',
    skin: 'Skin',
    items: 'artículos',
    items_v2: 'artículos',
    buy_orders: 'Pedidos de compra',
    search_for: 'Buscar objetos de {game}',
    search_for_items: 'Buscar artículos',
    reload: 'Reinicia',
    item_name: 'Nombre del artículo',
    enter_item_name: 'Introduce el nombre del artículo',
    price: 'Precio',
    reset: 'Restablece',
    all_items: 'Todos los artículos',
    sort: 'Clasificar',
    add_sort: 'Añadir orden',
    steam_price: 'Precio de Steam',
    reference_price: 'Precio de referencia',
    steam_inventory: 'Inventario de Steam',
    your_steam_inventory: 'Tu inventario de Steam',
    bitskins_inventory: 'Inventario BitSkins',
    your_bs_inventory: 'Tu inventario de BitSkins {extra}',
    refresh: 'Actualiza',
    learn_how_to_sell: 'Aprende como vender',
    select_1_by_1: 'Selecciona 1 por 1',
    select_all: 'Seleccionar todo',
    selected_items: 'Elementos seleccionados',
    items_amount: '{count} artículos',
    offers: 'ofertas',
    favorites: 'Favoritos',
    last: 'Último',
    viewed: 'visto',
    same_price: {
      same_price_for: 'Mismo precio para',
      all_items: 'todos los artículos',
    },
    save_all: 'Guardar todo',
    trade_hold: {
      name: 'Comercio retenido',
      between: 'Bloqueado entre {min} y {max} días',
      less: 'Bloqueado durante menos de {value} días',
      any: 'Cualquier retención comercial',
      none: 'Sin bloqueo comercial',
      withdrawable_in_days_hours: 'Retirable en {days} días, {hours} horas',
      withdrawable_in_hours_minutes: 'Retirable en {hours} horas, {minutes} minutos',
      tradable: 'Comerciable',
    },
    filter: {
      status: 'Estado',
      date_from: 'Fecha de',
      date_to: 'Fecha a',
      amount_from: 'Importe de',
      amount_to: 'Importe a',
      price_from: 'Precio desde',
      price_to: 'Precio a',
      service: 'Servicio',
      item: 'Artículo',
      game: 'Juego',
      type: 'Tipo',
      quality: 'Calidad',
      exterior: 'Exterior',
      category: 'Categoría',
      collection: 'Colección',
      color: 'Color',
      family: 'Familia de skin',
      phase: 'Fase',
      rarity: 'Rareza',
      grade: 'Grado',
      killstreak: 'Racha de bajas',
      effect: 'Efecto',
      hero: 'Héroe',
      nametag: 'Etiqueta con el nombre',
      hightier: 'Alto nivel',
      stickers: 'Pegatinas',
      slot: 'Ranura {value}',
      paint_seed: 'Semilla de pintura',
      paint_index: 'Índice de pintura',
      sticker_counter: 'Cantidad de pegatinas',
      float_value: 'Índice de desgaste ',
      active: '{value} activo',
      by_slot_position: 'Por posición de la ranura',
      filter_name: 'Filtros de nombres',
      you_can_have: 'Puedes tener',
      filters_saved: 'filtros guardados.',
      choose_stickers: 'Elige pegatinas',
      no_stickers_found: 'No se han encontrado pegatinas',
      basic_filters: 'Filtros básicos',
      advanced_filters: 'Filtros avanzados',
      clear_all_filters: 'Borrar todos los filtros',
      save_filters: 'Guardar filtros',
      my_filters: 'Mis filtros',
      filters_are_not_available_on_this_page: 'Los filtros no están disponibles en esta página',
    },
    loading_item: 'Cargando artículo ',
    bestseller: 'Mejor vendido',
    this_is_your_item: 'Este es tu artículo',
    action: {
      screenshot: 'Captura de pantalla',
      inspect: 'Inspeccionar en el juego',
      view_at_steam: 'Ver en Steam',
      check_on_steam_market: 'Consulta el mercado de Steam',
      share: 'Comparte',
      sell_instantly: 'Vende instantáneamente ',
      buy: 'Comprar',
      remove_from_sale: 'Retirar de la venta',
      check_on_market: 'Consulta el mercado',
      item_page: 'Página del artículo',
      bulk_buy: 'Comprar en gran cantidad',
      add_to_favorites: 'Añadir a favoritos',
      remove_from_favorites: 'Eliminar de favoritos',
      buy_now: 'Comprar ahora',
      bump: 'Promoción ',
      sticker: 'Artículos con esta pegatina',
    },
    bump_minimum: 'La promoción sólo está disponible para artículos de valor superior a {amount}.',
    your_price: 'Tu precio',
    cart: {
      add_to_cart: 'Añadir a la cesta',
      remove_from_cart: 'Eliminar del carrito',
      add_stickers_to_cart: 'Añadir pegatinas a la cesta',
      remove: 'Elimina',
      in_cart: 'En carrito',
    },
    details: 'Detalles',
    tags: 'Etiquetas',
    do_you_want_rename: '¿Quieres cambiar el nombre de tu artículo?',
    currently_not_available: 'Actualmente no disponible',
    nametag: 'Etiqueta con el nombre',
    sales: 'Ventas',
    private_offer: 'Oferta privada',
    private_offers: 'Ofertas privadas',
    private_offers_description: 'Tienes {counter} ofertas privadas. Puedes encontrarlas',
    public_offer: 'Oferta pública',
    offer_visible_only_to_people_with_link: 'Esta oferta sólo es visible para las personas que tienen un enlace a ella',
    checkout: {
      if_any: 'Si alguno de los artículos de tu cesta ya no está disponible, no se añadirá a tu pedido.',
      remove_all_items: 'Eliminar todos los elementos',
      order_summary: 'Resumen del pedido',
      you_will_save: 'Ahorrarás',
      i_have_read: 'He leído y acepto las Condiciones del servicio y la Política de privacidad y entiendo que todas las compras son definitivas y no reembolsables.',
      confirm_checkout: 'Confirmar pago',
      you_need_to_deposit_at_least_x: 'Necesitas ingresar al menos {amount} para comprar los artículos de tu cesta.',
      you_cannot_complete: 'No puedes completar tu pedido porque no tienes fondos suficientes en tu cuenta. Necesitas ingresar al menos {amount} para comprar los artículos de tu cesta.',
      these_items_will_be_removed: 'Estos artículos se eliminarán de la lista después de la compra.',
      this_item_will_not_be_included: 'Este artículo no se incluirá en tu pedido',
      need_tos_accept: 'Debes aceptar las Condiciones del servicio y la Política de privacidad',
      no_items_selected: 'No hay elementos seleccionados',
    },
    deposit_status: {
      available: 'Disponible',
      missing: 'Falta',
      not_accepting: 'No aceptando',
      wrong_price: 'Precio incorrecto',
      already_queue: 'Ya en cola',
      locked: 'Bloqueado',
    },
    withdraw_progress: {
      status: 'Estado de retiro',
      selected: 'Seleccionado',
      waiting: 'Esperando',
      in_queue: 'En cola',
      trade_link: 'Enlace comercial',
      done: 'Hecho',
      error: 'Error',
      failed: 'Fallido',
      pending: 'Pendiente',
    },
    trade_state: {
      Invalid: 'Invalido ',
      Active: 'Activo',
      Accepted: 'Aceptado',
      Countered: 'Contraoferta ',
      Expired: 'Caducado',
      Canceled: 'Cancelado',
      Declined: 'Rechazado',
      InvalidItems: 'Elementos no válidos',
      CreatedNeedsConfirmation: 'Creado, necesita confirmación',
      CanceledBySecondFactor: 'Anulado por el segundo factor',
      InEscrow: 'En depósito',
    },
    trade_type: {
      deposit: 'Depósito',
      withdraw: 'Retirar',
      bidirectional: 'Bidireccional',
    },
    inventory: {
      history: 'Historia',
      active_trades: 'Operaciones activas',
      loading_your_inventory: 'Cargando tu inventario',
      lower_sale_fee: '{value}% menos de comisión de venta',
      group_diff_price: 'No todos los artículos del grupo tienen el mismo precio',
      group_diff_delist: 'No todos los elementos del grupo están marcados para ser borrados de la lista',
      delist: 'Suprimir',
      this_may_take_a_while: 'Esto puede llevar un tiempo',
      relist_items: 'Volver a listar artículos',
      cancel_relisting: 'Anular el listado',
      cancel_withdrawal: 'Cancelar la retirada',
      withdraw_items: 'Retirar artículos',
      cancel_editing: 'Dejar de modificar ',
      edit_items: 'Editar elementos',
      sell_items: 'Vender artículos',
      steam_offers: 'Ofertas de Steam',
      clear_withdraw_items: 'Borrar elementos',
      loading_inventory: 'Cargando inventario',
      update_x_items: 'Actualizar {amount} elementos',
      delist_x_items: 'Suprimir {amount} elementos',
    },
    message: {
      failed_to_create_trade_offer: 'No se ha podido crear la oferta',
      offer: 'Oferta {hash}',
      offer_failed: 'Oferta fallida (con estado {state})',
      offer_confirmed: 'Tu oferta ha sido confirmada y has puesto a la venta con éxito tus artículos',
      offer_sent: 'Tu oferta de intercambio ha sido enviada',
      open_trade: 'Oferta comercial abierta',
      withdraw: 'Retirar oferta {hash}',
      withdraw_confirmed: 'Tu retirada ha sido aceptada',
      offer_preparing: 'Se está preparando tu intercambio. En breve te enviaremos la oferta',
      offer_active: 'Tu operación está lista. Acepta aquí',
      offer_needs_confirmation: 'Confirmar operación en aplicación móvil',
    },
    deposit_type: {
      public: 'Público',
      public_description: 'Tus artículos serán visibles para todos los usuarios de BitSkins. Esta es la opción de venta más popular.',
      private: 'Privado',
      private_description: 'Tus artículos sólo serán visibles para las personas que tengan un enlace a ellos. La venta privada es un 50% más barata que la venta estándar.',
      instant_sell: 'Venta instantánea',
      instant_description: 'Tras enviar los artículos a nuestro bot, el dinero se abonará en tu cuenta inmediatamente.',
    },
    click_to_open: 'Haz clic para abrir el enlace en una pestaña nueva',
    no_active_trades: 'No hay operaciones activas',
    go_to_all_trades: 'Ir a todos los intercambios',
    update_trade_link: 'Actualizar enlace de intercambio',
    withdraw: 'Retirar',
    lowest_price: 'El precio más bajo:',
    no_filters_available: 'No hay filtros disponibles',
    select_a_hero: 'Selecciona un héroe:',
    view_all_items: 'Ver todos los artículos',
    stattrak: 'StatTrak',
    item_not_available: 'Este artículo ya no está disponible',
    out_of_stock: 'Agotado',
    find_similar_item: 'Buscar artículos similares',
    find_similar_items: 'Buscar artículos similares',
    sell_for: 'Vender por',
    recommended: 'Recomendado',
    price_discounted: 'Precio con descuento',
    price_average: 'Precio medio (recomendado)',
    price_expensive: 'Precio elevado',
    sticker: 'pegatina',
    more: 'Más',
    recent: 'Recientes',
    item_not_found: 'Artículo no encontrado',
    for: 'para',
    you_will_pay: 'Pagarás',
    fade: 'Desvanecer: {value}%',
    see_all_items: 'Ver todos los artículos de {amount}',
    it_my_take_a_while: 'Esto puede llevar un tiempo',
    no_transactions_found: 'No se han encontrado transacciones',
    item: 'Artículo',
    edit: 'Modificar',
    add_items_to_edit: 'Añadir elementos para editar',
    add_items_to_delist: 'Añadir elementos para retirar',
    add_items_to_sale: 'Añadir artículos a la venta',
    add_items_to_withdraw: 'Añadir elementos a retirar',
    group_by_name: 'Agrupar por nombre',
    select_items_from_your_inventory: 'Selecciona objetos de tu inventario',
    earnings: 'Ganancias',
    total_fee: 'Tasa total',
    total_amount: 'Importe total',
    confirm_purchase: 'Confirma <span class="text-cp">la compra</span>',
    thank_you_for_shopping_with_us: '<span class="text-cp">¡Gracias</span> por comprar con nosotros!',
    you_have_purchased_x_items_for: 'Has comprado <span class="text-cp">{x}</span> artículos para',
    you_have_purchased_x_for: 'Has comprado <span class="text-cp">{x}</span> por',
    total: 'Total',
    you_saved: 'Has ahorrado',
    see_your_inventory: 'Ver tu inventario',
    you_bought: 'Has comprado',
    order_details: 'Detalles del pedido',
    items_not_available: 'Lamentablemente, algunos de los artículos de tu cesta no están disponibles, por lo que no has podido comprarlos. A continuación encontrarás una lista de estos artículos.',
    total_price: 'Precio total',
    withdraw_all_items: 'Retirar todos los artículos',
    private_listing: 'Listado privado {extra}',
    public_listing: 'Listado público {extra}',
    instant_sale_price: 'Precio de venta instantáneo',
    not_accepted: 'No aceptada',
    not_available: 'No disponible',
    no_sales_data: 'No hay datos de ventas',
    create_buy_order: 'Crear orden de compra',
    active_buy_orders: 'Tus órdenes de compra activas',
    buy_orders_history: 'Historial de órdenes de compra',
    market_buy_orders: 'Órdenes de compra a mercado',
    recent_sales: 'Ventas recientes',
    selling_price: 'Precio de venta',
    sales_chart: 'Gráfico de ventas',
    sales_history_will_be_available_soon: 'El historial de ventas de BitSkins y Steam estará disponible en breve',
    souvenir: 'Recuerdo',
    under: '{amount} y menos de',
    above: '{amount} y más',
    amount_to_amount: 'de {amount1} a {amount2}',
    discount: 'Descuento',
    value_off_or_more: '{value}% de descuento o más',
    removed_items: 'Elementos eliminados',
    restore_all_items: 'Restaurar todos los elementos',
    add_x_items_to_edit: 'Añadir {amount} elementos a editar',
    add_x_items_to_sale: 'Añadir {amount} artículos a la venta',
    add_x_items_to_withdraw: 'Añadir {amount} artículos a retirar',
    sell_x_items: 'Vender {amount} artículos',
    withdraw_x_items: 'Retirar {amount} artículos',
    first_you_need_to_select_an_item: 'Primero tienes que seleccionar un elemento.',
    cheapest_price_on_bitskins: 'El precio más barato en BitSkins:',
    final_price: 'Precio final:',
    check_quantity: 'Comprobar cantidad',
    cancel_selected_orders: 'Cancelar pedidos seleccionados',
    cancel_all_orders: 'Cancelar todos los pedidos',
    community_rating: 'Calificación comunitaria:',
    rating: 'Clasificación',
    votes: 'votos',
    open_image: 'Abrir imagen',
    cheaper_than_steam_by_x: 'Más barato que el vapor en un {x}%.',
    there_are_other_items_you_may_like: '<span>Hay otros artículos</span> que te pueden gustar...',
    available_variants: 'Variantes disponibles',
    picture: {
      playside: 'Parte frontal',
      backside: 'Parte trasera',
      steam: 'Imagen del mercado de Steam',
    },
    buy_orders_not_available: 'Las órdenes de compra no están disponibles actualmente',
    confirm_price_change: 'Confirmar cambio de precio',
    are_you_sure_to_change_price: '¿Estás seguro que quieres cambiar el precio de  {price} ?',
  },
  bumps: {
    heading: '¿Te gustaría <span class="text-cp">vender tus artículos más rápido</span> sin bajar su precio?',
    subheading: '¡Tenemos algo para ti!',
    how_it_works: '<span class="text-cp">¿Cómo</span> funciona?',
    description: 'En BitSkins tenemos una opción de promoción que te permite destacar tus artículos en la página de mercado y en algunos otros lugares del sitio web. Es una solución perfecta para quien quiera acelerar el proceso de venta de artículos sin tener que bajar su precio. Cuando promocionas un artículo, lo verá más gente y aumentarán las posibilidades de venderlo. Puedes empezar a promocionar por sólo 0,75 $ o incluso menos (consulta nuestros paquetes de promociones).',
    your_active_x_autobumps: 'Tus promociones activas {x}',
    bumps_packages: 'Paquetes de promociones',
    bumps: 'promociones',
    bumps_title: 'Promociones',
    available_bumps: 'Promociones disponibles',
    buy_selected_package: 'Comprar el paquete seleccionado',
    when_you_bump: 'Cuando promociones un elemento, se mostrará en los siguientes lugares:',
    step_1_title: 'En la página del mercado, en la <span class="text-cp">barra superior</span>',
    step_2_title: 'En la página del mercado, en la <span class="text-cp">sección principal</span>',
    step_2_text: '(Sólo si la opción de ordenación está configurada como "destacado". Ésta es la opción por defecto).',
    step_3_title: 'En la <span class="text-cp">página de inicio</span>',
    step_4_title: 'En la página del artículo, en la sección <span class="text-cp">artículos similares</span>.',
    step_5_title: 'En la sección <span class="text-cp">elementos sugeridos</span>',
    after_bumping: '<span class="text-cp">Después de promocionar un artículo, éste se mostrará <span class="text-cp">en primer lugar</span> en cada sección. Sin embargo, <span class="text-cp">si otra persona promociona su artículo después de ti</span>, tu artículo pasará al <span class="text-cp">segundo lugar</span>. Tu artículo será visible en cada sección siempre que no haya suficientes golpes que lo empujen fuera de la sección.',
    how_to_bump: '<span class="text-cp">¿Cómo promociono mi artículo?',
    how_to_1: 'Abrir el menú de artículos ',
    how_to_2: 'Selecciona la opción <span class="text-cp">promoción</span>.',
    how_to_3: 'Elige el tipo de promoción ',
    how_to_4: '¡Hecho!',
    table: {
      item: 'Artículo',
      quantity: 'Cantidad',
      left: 'Izquierda',
      period: 'Periodo',
      created_at: 'Creado en',
      updated_at: 'Actualizado en',
      next_bump_at: 'Próxima promoción en',
      action: 'Acción',
      status: 'Estado',
    },
    auto_enabled: 'Promoción automático activado',
    auto_disabled: 'Promoción automática cancelado',
    single_bumped: '¡El artículo ha sido promocionado!',
  },
  buy_order: {
    confirm_buy_orders_cancellation: 'Confirmar compra de <span class="color-primary">anulación de pedidos</span>',
    are_you_sure_that_you_want_to_cancel: '¿Estás seguro de que quieres anular todas tus órdenes de compra?',
    create_buy_order: 'Crear <span class="text-cp">pedido de compra</span>',
    predict_place_in_queue: 'Predecir el lugar en la cola',
    your_place_in_the_queue: 'Tu lugar en la cola:',
    may_purchase_items_with_trade_hold: 'Las órdenes de compra pueden adquirir artículos con retención comercial.',
    create_a_buy_order_for_this_item: 'Crear una orden de compra para este artículo',
    no_buy_orders_found: 'No se han encontrado órdenes de compra',
    position_in_queue: 'Posición en la cola',
    this_is_your_buy_order: '(esta es tu orden de compra)',
    skin_name: 'Nombre de la skin:',
    offers_on_market: 'ofertas en el mercado',
  },
  instant_sell: {
    confirmation: 'Confirmación de venta instantánea',
    you_can_sell_x: 'Puedes vender AWP | Asiimov (Algo desgastado) al instante y recibir 10 $.',
    the_funds_will_be_credited: 'Los fondos se abonarán en tu cuenta inmediatamente. Si quieres continuar pulsa "Vender al instante"',
  },
  sort: {
    select_option: 'Selecciona una opción',
    apply: 'Aplica',
    clear: 'Limpiar',
    default_order_placeholder: 'Selecciona una opción',
    select_order_placeholder: 'Seleccionar un orden',
    default_sort: 'Orden por defecto',
    custom_sort: 'Orden personalizada',
    field: {
      price: 'Precio',
      discount: 'Descuento',
      id: 'Fecha añadida',
      bumped_at: 'Destacado',
      suggested_price: 'Precio sugerido',
      asset_id: 'Fecha añadida',
      float_value: 'Indice de desgaste',
      paint_index: 'Índice de pintura',
      paint_seed: 'Semilla de pintura',
      extras_1: 'Valor añadido',
      extras_1_fade: 'Desvanecer',
      amount: 'Importe',
      name: 'Nombre',
    },
    order: {
      price: {
        asc: 'El más barato primero',
        desc: 'Primero caro',
      },
      discount: {
        desc: 'Lo más alto primero',
      },
      id: {
        asc: 'El más antiguo primero',
        desc: 'Lo más nuevo primero',
      },
      asset_id: {
        asc: 'El más antiguo primero',
        desc: 'Lo más nuevo primero',
      },
      bumped_at: {
        desc: 'Por defecto',
        asc: '',
      },
      default: {
        asc: 'Lo más bajo primero',
        desc: 'Lo más alto primero',
      },
    },
  },
  pagination: {
    showing: 'Mostrando',
    to: 'de',
    of: 'de',
    records: 'registros',
  },
  popups: {
    click_confirmation_link: 'Comprueba la bandeja de entrada de tu correo electrónico y haz clic en el enlace de confirmación para completar el proceso.',
    steam_login_issue: {
      title: 'Problema de inicio de sesión en Steam',
      an_error_occured: 'Se ha producido un error al intentar iniciar sesión a través de Steam. Por favor, inténtalo de nuevo.',
    },
    steam_inventory_private: {
      title: 'Tu inventario de Steam es <span class="text-cp">privado</span>.',
      we_were: 'No hemos podido cargar tu inventario de Steam. Por favor, cambia el estado de tu inventario a público.',
      you_can: 'Puedes hacerlo en los ajustes de Steam. Ten en cuenta que pueden pasar unos minutos hasta que detectemos los cambios.',
      steam_settings: 'Ajustes de vapor',
    },
    account_deletion_in_progress: {
      title: 'Eliminación de cuenta en curso...',
      process_started: 'Has iniciado el proceso de eliminación de la cuenta.',
      account_will_be_deleted: 'Tu cuenta se eliminará el',
      cancel_deletion: 'Cancelar la eliminación',
      confirm_deletion: 'Confirmar eliminación',
      check_your_email: 'Comprueba tu correo electrónico',
    },
    account_deletion_confirm: {
      title: 'Confirmar la eliminación de la cuenta',
      subtitle: '¿Estás seguro de que quieres eliminar tu cuenta?',
      once_you_confirm: 'Una vez que lo confirmes, se cerrará automáticamente tu sesión y todos los datos de tu cuenta se eliminarán permanentemente al cabo de dos semanas. Durante estas dos semanas podrás cancelar el proceso de eliminación accediendo a tu cuenta.',
      once_your_account_is: 'Una vez eliminada tu cuenta, podrás crear una nueva cuenta BitSkins accediendo al sitio web.',
      however_you_will_not: 'Sin embargo, no tendrás acceso a los datos borrados.',
      if_you_want_to_continue: 'Si quieres continuar pulsa confirmar y haz clic en el enlace de confirmación del correo electrónico que te enviamos.',
      login: 'Debes iniciar sesión para confirmar la eliminación de la cuenta',
      canceled: 'Se ha cancelado la eliminación de la cuenta',
      confirmed: 'Confirmada la eliminación de la cuenta',
    },
    account_deletion_check_your_email: {
      title: 'Comprueba tu correo electrónico',
      to_complete: 'Para completar el proceso de eliminación de la cuenta, haz clic en el enlace de confirmación del correo electrónico que te enviamos.',
    },
    twofa_enable: {
      already_done: 'Ya has activado la 2FA.',
      setup_email_before: 'Para activar la 2FA, primero tienes que configurar el correo electrónico.',
      twofa_authentication_adds: 'La autenticación de dos factores (2FA) añade una capa adicional de seguridad a tu cuenta al requerir dos métodos (factores) para verificar tu identidad. Se recomienda encarecidamente activar la 2FA para mantener segura tu cuenta, ya que impide inicios de sesión no deseados sin acceso a un código 2FA adicional.',
      setup_twofa: 'Configura la autenticación de dos factores',
      if_you_dont_have_an_authenticator_app: 'Si <span class="text-cp">no tienes</span> una aplicación autenticadora',
      we_recommend: '<p>Recomendamos <a href="https://support.google.com/accounts/answer/1066447?hl=en" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Google Authenticator</a> o <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> para usuarios de Android e iOS. Si quieres utilizar la aplicación en tu ordenador, puedes descargar e instalar <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> o utilizar<a href="https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Extensión Google Authenticator</a> en tu navegador.',
      scan_the_qr_code: '<span class="text-cp">Escanea</span> el código QR',
      open_your_authenticator_app: 'Abre tu aplicación de autenticación y escanea el código QR o introduce la clave secreta manualmente.',
      secret_key: 'Clave secreta',
      this_secret_key_will_be_valid_for_x_seconds: 'Esta clave secreta será válida durante <span class="text-cp">{x} @:{\'time.seconds\'}</span>',
      save_this_secret: 'Guarda esta clave secreta en un lugar seguro. Te permitirá recuperar el acceso a tus códigos 2FA<br> cuando pierdas el acceso a la aplicación del autenticador.',
      enter_the_6_digit_code: 'Introduce el <span class="text-cp">código de 6 dígitos</span> generado por tu aplicación autenticadora',
      enter_the_code_from_the_email: 'Introduce el código del <span class="text-cp">correo electrónico</span>.',
      enter_the_verification_code: 'Introduce el código de verificación que te enviamos a <span class="text-cp">{email}</span>.',
      desktop: 'Escritorio',
    },
    twofa_enabled: {
      now_your_account_is: 'Ahora tu cuenta está protegida por la autenticación de dos factores.',
      all_future_logins: 'Todos los inicios de sesión futuros requerirán que introduzcas un código suministrado por tu aplicación de autenticación.',
    },
    twofa_enter_code: 'Introduce el código 2FA generado por tu aplicación de autenticación.',
    twofa_disable: {
      title: 'Desactivar la autenticación de dos factores',
      enter_the_6_digit_code: 'Introduce el código de 6 dígitos generado por tu aplicación de autenticación.',
      cannot_access: '¿No puedes acceder a tu código de verificación? Ponte en contacto con nosotros en',
    },
    twofa_disabled: 'Tu cuenta ya no está protegida por la autenticación de dos factores.',
    order_unable_to_process: {
      title: 'No hemos podido <span class="text-cr">tramitar tu pedido</span>.',
      an_error_occurred: 'Se ha producido un error al procesar tu pedido.<br> Por favor, vuelve a la página de pago e intenta realizar el pedido de nuevo.',
      back_to_checkout: 'Volver a la caja',
      back_to_item: 'Volver al artículo',
      information: 'Si este error se produce a menudo, debes ponerte en contacto con nosotros a través de la <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">página de soporte</a> incluyendo el código de error:',
    },
    phone_number_add: {
      title: 'Añade tu número de teléfono',
      to_continue: 'Para continuar, primero tienes que añadir tu número de teléfono a tu cuenta.',
      add_number: 'Añadir número',
    },
    phone_number_confirmed: {
      title: 'Número de teléfono confirmado',
      your_phone_number: 'Tu número de teléfono ha sido confirmado.',
    },
    phone_number_verify: {
      title: 'Verifica tu número de teléfono',
      to_verify: 'Para verificar tu número de teléfono tienes que introducir el código de verificación que enviamos a',
      enter_sms_code: 'Introduce el código SMS',
      you_cannot_update: 'No puedes actualizar tu número de teléfono en este momento. Podrás hacerlo en {minutes} minutos.',
    },
    phone_number_verification_in_progress: {
      title: 'Verificación del número de teléfono en curso',
      if_you_wish: 'Si lo deseas, puedes actualizar tu número de teléfono o volver a enviar el código de verificación.',
      send_code: 'Enviar código',
    },
    email_address_add: {
      your_email_address: 'tu dirección de correo electrónico',
      by_providing_my_email: 'Al facilitar mi dirección de correo electrónico, acepto recibir comunicaciones de marketing',
      verification_in_progress: 'Verificación de correo electrónico en curso',
      to_verify: 'Para verificar tu dirección de correo electrónico tienes que hacer clic en el enlace de confirmación del correo electrónico que enviamos a',
      if_you_wish: 'Si lo deseas, puedes actualizar tu dirección de correo electrónico o reenviar el enlace de activación.',
    },
    email_address_verify: {
      we_are_verifying: 'Estamos verificando tu dirección de correo electrónico y puede tardar un poco...',
      confirmed: 'Tu dirección de correo electrónico ha sido confirmada.',
    },
    email_address_confirmed: {
      title: 'Dirección de correo electrónico confirmada',
      your_email_address: 'Tu dirección de correo electrónico ha sido confirmada.',
    },
    enter_your_trade_url: {
      title: 'Introduce tu <span class="text-cp">url de comercio</span>',
      to_continue: 'Para continuar, primero tienes que configurar tu url de comercio. La encontrarás en',
      your_trade_url: 'Tu url comercial',
    },
    password_reset_enter_email: {
      forgot: 'Olvidaste tu',
      password: '¿contraseña?',
      dont_worry: 'No te preocupes, introduce tu dirección de correo electrónico a continuación.',
      we_will_send: 'Te enviaremos un enlace para restablecer tu contraseña.',
      send_reset_link: 'Enviar enlace de reinicio',
      if_this_email: 'Si esta dirección de correo electrónico está asociada a una cuenta de BitSkins,',
      you_will_receive: 'recibirás un correo electrónico con un enlace para restablecer tu contraseña.',
    },
    password_reset_new_password: {
      enter_your: 'Introduce tu',
      new_password: 'nueva contraseña',
      enter_password: 'Introduce la contraseña',
      repeat_password: 'Repite la contraseña',
      save_password: 'Guardar contraseña',
    },
    link_expired: {
      title: 'Enlace caducado',
      the_process_cannot: 'Este proceso no puede completarse. El enlace ya ha caducado.',
      go_to_settings: 'Ir a ajustes',
    },
    wrong_link: {
      title: 'Enlace incorrecto',
      we_were_unable: 'No hemos podido procesar tu solicitud. Has seguido un enlace incorrecto.',
    },
    trade_preparing: {
      title: 'Estamos preparando tu oferta comercial',
      processing: 'Puede tardar unos segundos...',
    },
    trade_sent: {
      trade_offer_has_been_sent: 'Tu oferta comercial tiene <span class="text-cp">enviado</span>',
    },
    trade_done: {
      title: 'La oferta comercial ha sido <span class="text-cp">aceptada</span>.',
      listed: 'Has puesto a la venta con éxito tus artículos. Puedes gestionarlos en la <a rel="nofollow noopener noreferrer" href="https://bitskins.com/selling" class="text-cp">pestaña de venta</a>.',
      see_listed: 'Ver tus artículos de la lista',
      withdrawn: 'Has retirado correctamente tus artículos.',
    },
    trade_declined: {
      your_trade_offer_has_been: 'Tu oferta de intercambio ha sido',
      declined: 'declinó',
      if_you: 'Si no lo rechazaste tú mismo, significa que alguien está utilizando tu cuenta y tus objetos pueden correr peligro de robo.',
      to_stay: 'Para proteger tus objetos debes actuar con rapidez y seguir estos pasos:',
      step_revoke: 'Revoca tu Clave Web API de Steam.',
      step_revoke_btn: 'REVOCAR CLAVE API',
      step_password: 'Cambia tu contraseña de Steam.',
      step_password_btn: 'CAMBIAR CONTRASEÑA',
      step_deauth: 'Desautoriza todos los dispositivos en Steam.',
      step_deauth_btn: 'DESAUTORIZAR DISPOSITIVOS',
      step_trade: 'Crea una nueva URL de comercio en Steam.',
      step_trade_btn: 'CREAR NUEVA URL DE COMERCIO',
      step_new: 'Establece tu nuevo enlace comercial en BitSkins.',
      step_new_btn: 'ESTABLECER NUEVA URL DE COMERCIO',
      step_try: 'Intenta depositar tus objetos de nuevo y comprueba si el problema persiste.',
      step_try_if: 'Si sigue ocurriendo, detén todas las operaciones y ponte en contacto con nuestro servicio de asistencia.',
      contact_support: 'Contactar con asistencia',
      information: 'Ten en cuenta que los miembros de nuestro personal y los bots nunca te pedirán ningún depósito a través del chat de Steam, Discord o cualquier otro lugar - cualquiera que afirme ser un administrador, etc. es falso y lo más probable es que quiera estafarte. ¡Mantente a salvo!',
    },
    trade_failed: {
      offer_failed_title: 'Oferta comercial <span class="text-cr">fracasada</span>',
      offer_failed_text: 'Lamentablemente, tu oferta de intercambio ha fallado. Por favor, inténtalo de nuevo.',
      offer_failed_to_create_title: '<span class="text-cr">No se ha podido</span> crear una oferta de intercambio',
      offer_failed_to_create_text: 'Lamentablemente, no hemos podido crear tu oferta de intercambio. Por favor, inténtalo de nuevo.',
      contact_support: 'Si este error se produce a menudo, debes ponerte en contacto con nosotros a través de la <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">página de soporte</a>.',
      support_page: 'página de apoyo',
      cannot_process: 'No podemos tramitar tu oferta de intercambio',
      unfortunately_we_were_unable: 'Lamentablemente, no hemos podido procesar tu oferta de intercambio. Lo más probable es que ya tengas una oferta de intercambio activa para estos artículos.',
    },
    items_not_available: {
      title: 'Los artículos ya no están disponibles para la venta',
      unfortunately: 'Lamentablemente, los artículos de tu cesta <span class="text-cy-secondary">ya no están disponibles para la venta</span>.',
      dont_worry: 'No te preocupes, puedes encontrar muchos artículos en la página del mercado.',
      unavailable_items: 'Artículos no disponibles',
      back_to_market: 'Volver al mercado',
    },
    bump_purchase_confirmation: {
      title: 'Confirmación de compra',
      do_you_want_to_purchase: '¿Quieres comprar <span class="text-cp">{quantity} promociones</span> por <span class="text-cp">{price}</span>?',
      bumps_package: 'paquete promociones',
    },
    bump_start: {
      title: 'Promociona tu artículo',
      bump_your_item: 'Promociona tu artículo para que aparezca en la página de mercado y en otros lugares del sitio web.<br> Esto puede ayudarte a vender tu artículo más rápido porque lo verá más gente.<br> Si quieres saber más sobre cómo funciona la función de promoción',
      click_here: 'haz clic aquí',
      single_bump: 'Promoción única',
      autobumps: 'Promociones automáticas',
      one_bump: '1 promoción',
      this_option_single_bump: 'Esta opción promocionará tu artículo una sola vez y cuesta <span class="text-cp">0,75$</span>. Si ya tienes promociones disponibles en tu cuenta, no se cargará nada de tu saldo.',
      this_option_autobumps: 'Esta opción promocionará cada periodo de tiempo seleccionado. Si ya tienes promociones disponibles en tu cuenta, no se cargará nada de tu saldo. Si te quedas sin promociones, se restarán <span class="text-cp">0,75$</span> de tu saldo en cada promoción. <span class="text-cp">Puedes comprar más promociones por adelantado</span> y al mismo tiempo <span class="text-cp">ahorrar algo de dinero</span> - desplázate hacia abajo para ver los paquetes de promociones.',
      bump_every: 'Promociona cada',
      bumps_amount: 'Cantidad de promociones',
      delayed_start: 'Inicio retardado',
      delayed_start_description: 'Al marcar esta opción, tu primera promoción se retrasará al periodo de tiempo seleccionado.',
    },
    bump_stop: {
      title: 'Detener las promociones automáticas',
      do_you_want: '¿Quieres detener las promociones automáticas para este artículo?',
    },
    bulk_buy: {
      bulk_buy: 'A granel <span class="text-cp">compra</span>',
      maximum_items_you_can_buy: 'Máximo de artículos que puedes comprar por este precio:',
      may_purchase_items_with_trade_hold: 'La función de compra a granel puede comprar artículos con retención comercial.',
    },
  },
  affiliate: {
    ad_info: 'Si no ves el recuadro, intenta desactivar el adblock.',
    affiliate_code: 'Código de afiliado',
    affiliate_link: 'Enlace de afiliación',
    level: 'Nivel',
    levels: '<span class="text-cp">Niveles de afiliación </span>.',
    our_levels: 'Nuestros niveles',
    your_code: '<span class="text-cp">Código de tu </span>afiliación',
    your_affiliate_statistics: '<span class="text-cp">Estadísticas de tu </span>afiliado</span>',
    earn_money_by_simply_sharing: '<span class="text-cp">¡Gana dinero</span> simplemente compartiendo tu amor por BitSkins con tu público!',
    percent_from_sale_fee: '{value}% de la tasa de venta',
    join_the_bitskins_affiliate: 'Únete al programa de afiliados de BitSkins y gana comisiones por cada venta realizada a través de tu enlace único de afiliado. Tanto si tienes muchos seguidores como unos pocos amigos íntimos, cuanto más compartas, más ganarás.',
    tile_1_title: 'Comparte BitSkins con tu público',
    tile_1_description: 'Crea tu propio enlace de afiliado en segundos y empieza a compartirlo con tus amigos o tu público.',
    tile_2_title: 'Observa cómo crecen tus beneficios',
    tile_3_title: 'Reclama tus ganancias',
    tile_3_description: 'Los fondos obtenidos del programa de afiliados se pueden gastar en la compra de artículos o se pueden retirar de BitSkins. ¡Depende de ti!',
    kyc_you_cannot_use: 'No puedes utilizar el sistema de afiliados porque no has pasado por el procedimiento KYC. Puedes iniciar el proceso de verificación ahora.',
    your_percentage: 'Tu porcentaje',
    generated: 'Generado',
    individual_affiliate_program: 'Programa de afiliación individual',
    if_you_or_your_business: 'Si tú o tu empresa estáis implicados en la industria de los esports o generáis un gran alcance en las redes sociales, ponte en contacto con nosotros a través de <span>partnership{\'@\'}bitskins.com</span>. Podemos ofrecerte condiciones de afiliación individuales.',
    invited_referrals: 'Referencias invitadas',
    active_referrals: 'Remisiones activas',
    your_percentage_sales_fee: 'Tu porcentaje de comisión por ventas',
    your_total_earnings: 'Tus ingresos totales',
    available_earnings: 'Ganancias disponibles',
    you_can_claim_your_earnings_one_a_day: 'Puedes reclamar tus ganancias una vez al día. Una vez que las reclames, aparecerán en tu saldo reintegrable en 24 horas. La cantidad mínima a pagar es',
    to_reach_the_next_level: 'Para alcanzar el siguiente nivel y ganar comisiones más altas, tienes que generar <span class="text-cp">{x}</span> en ventas a través de tus referidos.',
    any_user_that_registers_from_your_affiliate_link: 'Cualquier usuario que se registre desde tu enlace de afiliado será asignado automáticamente como tu árbitro',
    my_earnings: '<span class="text-cgs">Mis</span> ingresos',
    referred_users: '<span class="text-purple">Usuarios referidos',
    code_updated: 'Código de afiliado actualizado correctamente',
    not_enough_money: 'No hay dinero suficiente para transferir',
    account: 'Cuenta',
    referrals_sales: 'Historial de ventas de referencias',
  },
  profile: {
    hi: 'Hola',
    nav: {
      account: 'Cuenta',
      wallet: 'Cartera',
      transactions: 'Transacciones',
      statistics: 'Estadísticas',
      affiliate: 'Afíliate a',
      company: 'Empresa',
      trades: 'Oficios',
      items_history: 'Historial de artículos',
    },
    top_star: {
      you_are: 'Tú eres',
      top_star: 'ESTRELLA SUPERIOR',
      good_to_see_you: 'Hola "{username}", ¡qué alegría verte en BitSkins!',
      appreciate_using: 'Te agradecemos que hayas decidido utilizar nuestra plataforma,',
      extra_settings: 'Por eso hemos preparado para ti algunos ajustes adicionales.',
      show_nickname_selling: 'Mostrar mi apodo en la página del artículo mientras se vende',
      show_nickname_store: 'Resaltar mi apodo en la página de la tienda',
    },
    basic: {
      basic_information: 'Información básica',
      username: 'Nombre de usuario',
      change_username: 'Cambiar nombre de usuario',
      registration_date: 'Fecha de inscripción',
      email: 'Envía un correo electrónico a',
      change_email: 'Cambiar correo electrónico',
      password: 'Contraseña',
      change_password: 'Cambiar contraseña',
      phone: 'Número de teléfono',
      change_phone: 'Cambiar teléfono',
      hide_balance: 'Esconde tu saldo',
      hide_balance_description: 'La cantidad de fondos estará oculta en la cabecera, pero seguirá siendo visible tras pulsar en el monedero.',
    },
    security: {
      you_can_access_your_account: 'Puedes acceder a tu cuenta mediante una clave API. La documentación de nuestra API se encuentra en',
      api_status: 'Estado de la API',
      security: 'Seguridad',
      twofa: 'Autenticación de dos factores',
      temporarily_block_my_account: 'Bloquear temporalmente mi cuenta',
      temporarily_block_title: 'Temporalmente <span class="text-cr">bloquear mi cuenta</span>',
      temporarily_block_description: 'Si crees que tu cuenta ha sido comprometida, puedes bloquearla temporalmente.\\nDesbloquearemos tu cuenta tras ponernos en contacto con nuestro servicio de asistencia.',
      temp_blocked: 'Tu cuenta ha sido bloqueada temporalmente.\\nPonte en contacto con nuestro servicio de asistencia para aclarar la situación.',
      block_my_account: 'Bloquear mi cuenta',
      delete_account: 'Eliminar cuenta',
      delete_my_account: 'Eliminar mi cuenta',
      sessions: 'Sesiones',
      close_all_sessions: 'Cerrar todas las sesiones',
      current_session: 'Sesión actual',
      active_sessions: 'Sesiones activas',
      no_other_sessions: 'Ninguna otra sesión',
      removed: 'Eliminado',
      online: 'En línea',
      api_key: 'Clave API',
      api_key_not_available: 'La clave API sólo es visible una vez durante su creación',
      sensitive_hidden: 'Información sensible oculta',
      ip_whitelist: 'Lista blanca de IP',
      add_ip_to_whitelist: 'Añadir IP a la lista blanca',
      disable_api_confirm: 'Confirmar el revoque del acceso API',
      disable_api_content: '¿Estás seguro de que quieres eliminar el acceso de tu API en tu cuenta?',
    },
    store: {
      my_store: 'Mi tienda',
      store: 'almacenar',
      store_url: 'URL de la tienda',
      store_alias: 'Almacenar alias',
      id_store: 'ID TIENDA',
      hide_store: 'Ocultar la página de tu tienda',
      url_copied: 'URL de la tienda copiada',
      total_items: 'Total de artículos:',
      games: 'Juegos:',
    },
    setting: {
      account_email: 'Correo electrónico de la cuenta',
      update_email: 'Actualizar correo electrónico',
      setup_email: 'Configurar correo electrónico',
      update_password: '<span class="text-cp">Actualizar</span> contraseña',
      set_password: '<span class="text-cp">Establecer</span> contraseña',
      enter_current_password: 'Introduce la contraseña actual',
      password_changed: 'Contraseña cambiada',
      current_password: 'Contraseña actual',
      enter_new_password: 'Introducir nueva contraseña',
      repeat_new_password: 'Repite la nueva contraseña',
      save_new_password: 'Guardar nueva contraseña',
      new_password: 'Nueva contraseña',
      repeat_password: 'Repite la contraseña',
      account_2fa: 'Cuenta 2FA',
      enable_2fa: 'Activar 2FA',
      disable_2fa: 'Desactivar 2FA',
    },
    transaction: {
      amount: 'Importe',
      type: 'Tipo',
      details: 'Detalles',
      fee: 'Tasa',
      buyer_country: 'País del comprador',
      seller_country: 'País del vendedor',
      price: 'Precio',
      item_name: 'Nombre del artículo',
      transaction_history: 'Historial de transacciones',
      operation: 'Operación',
      trade_id: 'Identificación comercial',
      loading_trade_offers: 'Carga de ofertas comerciales',
      no_trades_found: 'No se han encontrado ofertas comerciales',
      id: 'ID',
      date: 'Fecha',
      game: 'Juego',
      items: 'Artículos',
      status: 'Estado',
      time_left: 'Tiempo restante',
      action: 'Acción',
      trades_active: 'Operaciones activas',
      trades_history: 'Historial comercial',
      balance: 'Saldo',
      history: 'Historial de transacciones',
      pending: 'Transacciones pendientes',
      reports: 'Informes exportados',
      active_locks: 'Cerraduras activas',
      export: 'Exportar',
      export_to_csv: 'Exportar a .CSV',
      export_description: 'Selecciona el mes y el año para los que quieres generar el informe.',
      the_report_will_appear_in_the: 'El informe aparecerá en el',
      tab_once_the_export_process_is_complete: 'una vez finalizado el proceso de exportación.',
    },
  },
  fee: {
    individual: 'Individual',
    individual_fee: 'cuota individual',
    custom_sale_fee: 'Tu tarifa de venta personalizada',
    your_current_fees: 'Tus tarifas actuales',
    high_tier: 'Nivel alto',
    fee: 'Tasa',
    fee_up_to: 'tarifa',
    sale_fee: 'Tasa de venta',
    sales_fees: 'Tasas de venta',
    see_all_levels: 'Ver todos los niveles',
    you_are_on_the: 'Estás en el',
    maximum_sales_fee: 'Tasa máxima de venta: {value}',
    your_total_sale_volume: 'Tu volumen total de ventas hasta ahora es de',
    sales_fees_will_be_lowered: 'Las comisiones de venta se reducirán a medida que vendas más artículos.',
    level: 'nivel',
    your_level: 'Tu nivel:',
    progress: 'Progreso:',
    max_level: 'Nivel máximo',
    next_level: 'Siguiente nivel:',
    total_income: 'Ingresos totales',
    total_revenue: 'Ingresos totales',
    sold_items: 'Artículos vendidos',
    page: {
      sales_fees_depends_on_two_factors: 'En BitSkins las <span class="text-cp">CUOTAS DE VENTA</span> dependen de dos factores:',
      the_price: '1. El precio al que vendes tu artículo',
      the_listing_type: '2. El tipo de listado:',
      listing_type_public: 'Público - tu artículo es visible para todos los usuarios del sitio web',
      listing_type_private: 'Privado - tu artículo sólo es visible para las personas con las que compartes el enlace',
      fee_explanation: 'Cuanto mayor sea el precio al que vendas tu artículo, menor será la comisión de venta que pagarás. La comisión de venta estándar va desde el 2,5% (para anuncios privados) hasta un máximo del 10% (para anuncios públicos). Además, tenemos 5 niveles de venta diferentes que te permiten reducir aún más las comisiones de venta. La regla es sencilla: cuanto más vendas, menos comisiones de venta pagarás. Puedes reducir tus comisiones de venta hasta un 2,4% (para anuncios privados) o hasta un 9,8% (para anuncios públicos). Nuestro sistema de comisiones es transparente y no hay comisiones ocultas.',
      default_sales_fees_title: '<span class="text-cp">Costes de venta por defecto</span>',
      default_sale_fees_description: 'Si acabas de empezar y aún no has vendido ningún artículo, tus comisiones de venta serán las siguientes:',
      how_to_reduce_my_sales_fees_title: '<span class="text-cp">¿Cómo reducir</span> mi comisión de venta?',
      how_to_reduce_my_sales_fees_description: 'En BitSkins tenemos 5 niveles de venta. Cada uno de ellos (excepto el Nivel 1) reduce tu comisión de venta en un 0,05%. Para subir de nivel, tienes que vender artículos a un determinado rango de precios.',
      sales_fees_levels: 'Ventas <span class="text-cp">niveles de tarifas</span>',
      price_range: 'Gama de precios',
      total_sales: 'Ventas totales',
      fee_reduced_by: 'Tasa reducida en',
      individual_sales_fees_title: 'Tasas de venta individuales',
      individual_sales_fees_description: 'Si utilizas bitskins de forma activa y tu facturación mensual es de al menos <span class="span text-csfl6">{amount}</span>, no dudes en ponerte en contacto con nosotros. Podemos ofrecerte una <span class="text-csfl6">tarifa de venta aún menor</span> y <strong>asistencia adicional</strong>.',
    },
  },
  copy: {
    text_copied: 'Texto copiado',
    cannot_copy: 'No se puede copiar',
    name_copied: 'Nombre copiado',
    cannot_copy_name: 'No se puede copiar el nombre',
    copy_link: 'Copiar enlace',
  },
  share: {
    share_on_twitter: 'Compartir en Twitter',
    share_on_facebook: 'Compartir en Facebook',
    share_on_telegram: 'Compartir en Telegram',
  },
  discord: {
    discord: 'Discordia',
    already_connected: 'Ya conectado',
    something_went_wrong: 'Algo salió mal',
    success: '¡Éxito!',
    loading: 'Cargando...',
    connect_with_discord: 'Conecta con Discordia',
  },
  telegram: {
    already_connected: 'Ya conectado',
    something_went_wrong: 'Algo salió mal',
    success: '¡Éxito!',
    loading: 'Cargando...',
  },
  error: {
    error_404: 'Error 404',
    page_not_found: 'Página no encontrada',
  },
  kyc: {
    description_1: 'Para garantizar la seguridad de las transacciones realizadas a través de nuestro sitio web y cumplir con la normativa AML/KYC aplicable, exigimos que te sometas a un proceso de verificación de datos (KYC). Existen tres niveles de verificación. Cada uno de los niveles aumenta o elimina completamente los límites y te da acceso a nuevos métodos de pago.',
    description_2_start: 'Las condiciones detalladas relativas al proceso de verificación KYC se describen en nuestras Condiciones del servicio. Nos gustaría asegurarte que todos los datos que nos proporciones se utilizarán de acuerdo con la',
    description_2_end: 'Al iniciar el proceso de verificación KYC, das tu consentimiento para que procesemos tus datos para los fines legalmente justificados.',
    personal_data: 'Datos personales',
    first_name: 'Nombre',
    middle_name: 'Segundo nombre',
    last_name: 'Apellidos',
    street_name: 'Nombre de la calle',
    street_number: 'Número de la calle',
    postal_code: 'Código postal',
    city: 'Ciudad',
    province: 'Provincia',
    country: 'País',
    start_kyc_verification: 'Iniciar la verificación KYC',
    upload: 'Sube',
    uploaded: 'Subido a',
    image_uploaded: 'Imagen cargada',
    document_type: {
      id: 'ID',
      driving_license: 'Permiso de conducir',
      passport: 'Pasaporte',
      other: 'Otros',
    },
    limit: {
      crypto_withdraw: 'Límite anual de retirada de criptomonedas de {amount}.',
      crypto_withdraw_unlimited: 'Retiradas ilimitadas de criptomonedas',
      non_crypto_withdraw: 'Límite anual de retiradas no criptográficas de {amount}.',
      non_crypto_withdraw_unlimited: 'Retiradas ilimitadas no criptográficas',
      crypto_deposit: 'Límite anual de criptodepósitos de {amount}.',
      crypto_deposit_unlimited: 'Depósitos ilimitados de criptomonedas',
      non_crypto_deposit: 'Límite anual de depósitos no criptográficos de {amount}.',
      non_crypto_deposit_unlimited: 'Depósitos ilimitados no criptográficos',
    },
    your_kyc_verification: 'Tu verificación KYC',
    your_kyc_needs_an_update: 'Tu CSC necesita <span class="color-update">una actualización</span>.',
    need_update_reason: 'Lamentablemente, no hemos podido aprobar tu cuenta por los siguientes motivos:',
    open_support: 'Apoyo abierto',
    your_kyc_has_been_denied: 'Tu KYC ha <span class="color-denied">sido denegado</span>',
    denied_description: 'Tu KYC ha sido denegado, por lo tanto no puedes volver a pasar por la verificación KYC.',
    deleted_description: 'Tu CSC ha sido denegado. Puedes volver a pasar por el proceso de verificación.',
    please_contact_our: 'Ponte en contacto con nuestro',
    support: 'ayuda',
    clarify_the_situation: 'para aclarar la situación.',
    your: 'Tu',
    kyc_title: 'Conoce a tu cliente <span class="text-cp">verificación</span>',
    verification: 'verificación',
    pending: 'está pendiente',
    pending_description: 'Eso es todo. Gracias por pasar por el proceso de verificación. Tus datos se han enviado correctamente. Haremos todo lo posible para verificar tu solicitud lo antes posible. Normalmente no tardamos más de 12 horas. Te enviaremos un correo electrónico cuando tu cuenta esté aprobada. Agradecemos tu paciencia.',
    do_you_need_help: '¿Necesitas ayuda? Ponte en contacto con nuestro',
    support_center: 'centro de apoyo',
    back_to_kyc: 'Volver a CSC',
    go_to_home: 'Ir al inicio',
    level_0: 'Nivel 0',
    level_1: 'Nivel 1',
    level_2: 'Nivel 2',
    limits: 'Límites',
    benefits: 'Beneficios',
    requirements: 'Requisitos',
    no_requirements: 'Sin requisitos',
    proof_of_address: 'Justificante de domicilio',
    all_benefits_from_the_basic_level: 'Todas las prestaciones del nivel básico',
    personal_information: 'Información personal',
    identity_document: 'Documento de identidad',
    selfie: 'Selfie',
    all_benefits_from_level_1: 'Todas las ventajas del nivel 1',
    current: 'Actual',
    upending: 'Pendiente',
    update: 'Actualiza',
    verification_blocked: 'Verificación bloqueada',
    verify_now: 'Compruébalo ahora',
    you_need_to_upgrade_to_level_1: 'Necesitas pasar al nivel 1',
    upgrade_to_level_1: 'Sube al nivel 1',
    upgrade_to_level_2: 'Sube al nivel 2',
    kyc_verification: 'Verificación KYC',
    kyc_verification_span: '<span class="color-primary">Verificación KYC</span>',
    kyc_verification_required: 'Se requiere verificación KYC',
    everything_done: '¡Todo hecho!',
    proof_of_residency: 'Prueba de residencia',
    you_current_residential_address: 'Tu dirección residencial actual',
    only_x_minutes: 'Sólo {minutes} ¡minutos!',
    identity_verification: 'Verificación de identidad',
    take_a_selfie: 'Hazte un selfie',
    step: 'Paso {step}',
    country_of_residence: 'País de residencia',
    full_name: 'Nombre y apellidos',
    date_of_birth: 'Fecha de nacimiento',
    nationality: 'Nacionalidad',
    choose_your_document: 'Elige tu documento',
    choose_document_description_1: 'Elige el documento que quieres utilizar durante la verificación.',
    choose_document_description_2: 'Sólo aceptamos documentos válidos expedidos por el gobierno.',
    choose_document_description_3: 'Cualquier otro documento que no figure en la lista será rechazado.',
    document_number: 'Número de documento',
    country_of_issue: 'País de emisión',
    document_issue_date: 'Fecha de emisión del documento',
    document_expiry_date: 'Fecha de caducidad del documento',
    files_requirements: 'Requisitos de los archivos',
    format: '{format} o {or} formato',
    maximum_file_size: 'Tamaño máximo del archivo {size}',
    minimum_picture_size: 'Tamaño mínimo de la imagen {size} píxeles',
    not_accepted_documents: 'Documentos no aceptados',
    expired: 'Caducado',
    edited: 'Editado',
    black_and_white: 'Blanco y negro',
    broken_or_damaged: 'Roto o dañado',
    illegible_blurred_or_reflective: 'Ilegible, borroso o reflectante',
    cut_off_or_overcropped: 'Cortado o con exceso de cultivos',
    upload_front_page: 'Subir portada',
    upload_back_page: 'Subir la contraportada',
    selfie_description: 'Por favor, sube una foto tuya sosteniendo tu DNI y un papel con tu nombre, "BitSkins.com" texto y la fecha de hoy.',
    example_of_correctly_taken_photo: 'Un ejemplo de foto correctamente tomada',
    with_sunglasses_cap_or_mask: 'Con gafas de sol, gorra o mascarilla',
    information_covered_by_finger: 'La información de tu documento está cubierta por tus dedos',
    face_covered_by_document: 'Tu cara está cubierta por tu documento',
    out_of_focus: 'Tu cara o tu documento están desenfocados',
    upload_selfie: 'Subir selfie',
    send_level_1_kyc_request: 'Enviar solicitud KYC de Nivel 1',
    address_line_1: 'Dirección línea 1',
    address_line_2_optional: 'Dirección línea 2 (opcional)',
    state_or_province: 'Estado o provincia',
    proof_of_residency_description: 'Por favor, sube un documento que demuestre tu dirección residencial actual que proporcionaste en el paso anterior. Asegúrate de que tu nombre completo aparece en el documento.',
    upload_document: 'Subir documento',
    accepted_documents: 'Documentos aceptados',
    utility_bills: 'Facturas de servicios públicos',
    bank_statements: 'Extractos bancarios',
    tax_returns: 'Declaraciones fiscales',
    government_letters: 'Cartas del Gobierno',
    other_document_residential: 'Otros documentos que confirmen tu dirección residencial actual',
    send_level_2_kyc_request: 'Enviar solicitud KYC de Nivel 2',
    submit: 'Envía',
    submit_correct: 'Envía la información correcta',
    next: 'Siguiente',
    send_to_verify: 'Enviar para verificar',
    document_verification: 'Verificación de documentos',
    level: 'Nivel KYC',
    please_reupload_following_photos: 'Por favor, vuelve a subir las siguientes fotos',
    please_reupload: 'Por favor, vuelve a cargar',
    we_need_additional_information: 'Necesitamos información adicional',
    file_format_not_supported: 'Este formato de archivo no es compatible.',
    the_file_is_too_big: 'El archivo {file_name} es demasiado grande ({file_size}),<br> máximo {size_limit}.',
    field: {
      document_image_a: 'Portada de tu documento',
      document_image_b: 'Contraportada de tu documento',
      user_image: 'Tu selfie',
      address_image: 'Prueba de residencia',
      additional_selfie: 'Selfie adicional',
    },
    back_to_bitskins: 'Volver a BitSkins',
    withdrawals: 'Retiradas',
    get_to_the_next_level: 'Pasa al siguiente nivel para librarte<br> de los límites y acceder<br> a nuevos métodos de pago.',
    after_the_first_page_is_validated: 'Una vez validada la primera foto, podrás subir la segunda página.',
    accepted: 'Aceptado',
  },
  camera: {
    cancel: 'Cancelar',
    check_permissions: 'Comprobar permisos',
    take_a_new_photo: 'Haz una nueva foto',
    take_a_photo: 'Haz una foto',
    use_camera: 'Utiliza la cámara',
    use_photo: 'Utiliza la foto',
    we_will_need_access_to_your_camera: 'Necesitaremos acceder a tu cámara para poder continuar.',
    please_follow_these_steps: 'Sigue estos pasos',
    select_the_camera_icon: 'Selecciona el <strong>icono de la cámara</strong> en tu barra de direcciones',
    select_always_allow_access: 'Selecciona <strong>Permitir siempre el acceso a tu cámara</strong>.',
    select_done: 'Selecciona <strong>Hecho</strong>.',
  },
  review: {
    leave_a_review: 'Deja una opinión',
    our_reviews: 'Nuestros comentarios',
    if_youre_happy: 'Si <span class="color-primary">estás contento</span> con el servicio, ',
    we_would_appreciate: 'te agradeceríamos que nos dejaras una <span class="color-primary">reseña en Trustpilot</span> compartiendo tu experiencia para ayudarnos. Muchas gracias.',
    if_youre_happy_we_would_appreciate: 'Si <span class="color-primary">estás satisfecho</span> con el servicio, te agradeceríamos que nos dejaras una <span class="color-primary">reseña en Trustpilot</span> compartiendo tu experiencia para ayudarnos. Muchas gracias.',
  },
  support: {
    center: 'Centro de asistencia',
    tickets_list: 'Lista de entradas',
    create_ticket: 'Crear ticket',
    submit_ticket: 'Enviar billete',
    close_ticket: 'Cerrar ticket',
    submit_disclaimer: 'Para acelerar nuestro trabajo y recibir una respuesta lo antes posible, asegúrate de no abrir varios tickets relativos al mismo problema. El tiempo medio de respuesta es de <strong>varias horas</strong>. Puedes contactar con nosotros en <strong>inglés, polaco y sueco</strong>. Gracias por tu colaboración.',
    enter_your_message: 'Introduce tu mensaje',
    new_ticket: 'Nuevo billete',
    your_ticket: 'Tu billete',
    bitskins_team: 'Equipo BitSkins',
    ticket_has_been_closed_by: 'La entrada ha sido <span>cerrada</span> por <span>{by}</span>',
    ticket_has_been_closed: 'La entrada ha sido <span>cerrada</span>',
    conversation_history: 'Historia de la conversación:',
    your_reply: 'Tu respuesta...',
    last_reply_by: 'Última respuesta por',
    send: 'Envía',
    ticket: 'Billete',
    title: 'Título',
    category: {
      payments: 'Pagos',
      payment_crypto_deposit: 'Depósito criptográfico',
      payment_crypto_withdraw: 'Retirada de criptomonedas',
      payment_standard_deposit: 'Método de depósito estándar',
      payment_standard_withdraw: 'Método estándar de retirada',
      market: 'Mercado',
      market_item_issue: 'Asunto',
      market_buy_orders: 'Orden de compra',
      market_bulk_buy: 'Compra a granel',
      market_missing_screenshot: 'Falta una captura de pantalla',
      market_missing_float: 'Falta flotador',
      market_wrong_price: 'Precio de Steam incorrecto',
      market_other: 'Otros',
      trading: 'Oficios',
      trading_deposit: 'Depósito de artículos',
      trading_withdraw: 'Artículo retirado',
      account: 'Cuenta',
      account_2fa: 'Problema 2FA',
      account_email: 'Problema de correo electrónico',
      account_kyc: 'KYC',
      account_affiliate: 'Sistema de afiliación',
      account_restrictions: 'Restricciones',
      account_other: 'Otros',
      other: 'Otros',
      bug_report: 'Informe de error',
      api: 'API',
      suggestions: 'Sugerencias',
      business_inquiry: 'Consulta comercial',
      general_inquiry: 'Consulta general',
    },
    extra: {
      txid_url: 'TXID/url',
      amount: 'Importe',
      crypto: 'Criptomoneda',
      disclaimer_visa_1: 'Ten en cuenta que es normal que pasen hasta 5 días laborables antes de que el dinero esté disponible en tu cuenta bancaria.',
      disclaimer_visa_2: 'Asegúrate de que lo que quieres retirar es una tarjeta Visa y no una Mastercard. Actualmente no podemos retirar dinero con Mastercard.',
      card_digits: '4 últimos dígitos de tu tarjeta',
      binance_id: 'Tu ID de Binance',
      wallet_address: 'Dirección de la cartera',
      provider: 'Proveedor',
      transaction_id: 'ID de transacción',
      type: 'Tipo',
      method: 'Método',
      item_link: 'Enlace al artículo',
      bot_received_item: 'Un enlace al perfil de Steam del bot\\ que recibió tus objetos',
      trade_offer_id: 'ID de la oferta comercial',
      can_be_found_here: 'se puede encontrar aquí',
      email: 'Introduce la dirección de correo electrónico',
    },
  },
  service: {
    market: {
      buy: 'Comprar',
      sell: 'Vende',
      fee: 'Tasa de venta',
      buy_order: 'Orden de compra',
      bargain: 'Ganga',
      instant_sell: 'Venta instantánea',
      bump: 'Promoción',
      bump_package: 'Paquete de promoción',
    },
    deposit: {
      gift_code: 'Código de regalo',
      bitcoin: 'Depositar BTC',
      litecoin: 'Depósito LTC',
      ethereum: 'Depositar ETH',
      unlimint: 'Depósito con tarjeta bancaria',
      binance_pay: 'Depositar con Binance Pay',
      binancepay: 'Depositar con Binance Pay',
      available_coupons: 'Cupones disponibles:',
      redeem_coupon: 'Canjear cupón',
      enter_coupon_code: 'Introduce el código del cupón',
      open_binance_website: 'Abrir el sitio web de Binance',
      list_of_active_transactions: 'Lista de transacciones activas:',
      transaction_needs_at_least_x_confirmations: 'La transacción necesita al menos {x} confirmaciones antes de que los fondos aparezcan en tu cuenta.',
      billing_information: '<span class="text-cp">Información de facturación</span>',
      coupon: {
        coupon: 'Cupón',
        make_a_gift: 'Hazte a ti mismo o a otra persona <span class="text-cp">un regalo</span>.',
        bitskins_coupons_are_a_good_alternative: 'Los cupones BitSkins son una buena alternativa a los métodos de pago estándar y una gran idea para hacer un regalo. Puedes comprarlos a nuestros socios que ofrecen muchos métodos de pago.',
        dont_wait: '<span class="text-cp">No esperes más y recarga tu saldo</span> con un cupón BitSkins o hazle a alguien<br> <span class="text-cp">un regalo original</span> (todos conocemos a alguien con el inventario vacío).',
        kinguin: 'Kinguin (nuevas tarifas reducidas)',
      },
      crypto: {
        get_wallet_address: 'Obtener la dirección del monedero',
        your_wallet_address: 'La dirección de tu monedero',
        this_address_is_only_for_x: 'Esta dirección es sólo para depósitos {x}. No envíes ningún otro cripto a esta dirección.',
        this_address_will_not_expire: 'Esta dirección no caducará. Puedes utilizarla en cualquier momento.',
        choose_alternative_address: 'Elige una dirección alternativa',
        the_acutal_amount_you_will_be_credited: 'El importe real que se te abonará dependerá del precio de {x} en el momento en que recibamos tu pago.',
        only_l1_transactions: '<span class="text-cyr">Sólo se admiten transacciones L1. No utilices transacciones internas ni contratos inteligentes.',
      },
      zen: {
        zen: 'Depósito con ZEN',
        deposit_started: 'Se inició el depósito ZEN, ',
        open_the_zen_deposit_page: 'abre la página del depósito ZEN',
        processing_fee: 'El ZEN añadirá a la transacción una tasa de tramitación que dependerá del método de pago seleccionado.<br> El importe final de la transacción será visible en su página web.',
        each_transaction_is_reviewed: 'Cada transacción es revisada por ZEN Pay y puede tardar <span class="text-cp">entre un minuto y unas horas</span> en completarse.',
      },
      the_minimum_deposit_amount_is: 'El importe mínimo del depósito es {amount}.',
      the_maximum_deposit_amount_is: 'El importe máximo del depósito es {amount}.',
    },
    withdraw: {
      only_binance_com_is_supported: '<span class="text-cyr">Ofrecemos pagos sólo a binance.com (binance.us no es compatible)</span>.',
      bitcoin: 'Retirar BTC',
      litecoin: 'Retirar LTC',
      ethereum: 'Retirar ETH',
      unlimint: 'Retirar fondos a una tarjeta VISA',
      tipalti: {
        tipalti: 'Retirarse con Tipalti',
        tipalti_allows_you_to_withdraw: 'Tipalti te permite retirar tus fondos a tu cuenta bancaria y PayPal.',
        you_dont_have_a_tipalti_acount: '¿No tienes una cuenta Tipalti?',
        you_have_to_create_an_account: 'Para retirar tus fondos a través de Tipalti primero tienes que crear una cuenta en su sitio web.<br> Puedes hacerlo haciendo clic en el botón de abajo.',
        create_tipalti_account: 'Crear cuenta Tipalti',
        check_your_email: 'Por favor, comprueba <span class="text-cp">tu bandeja de entrada de correo electrónico</span> y haz clic en el enlace de confirmación para completar el proceso de creación de la cuenta. Si no encuentras el mensaje de correo electrónico en tu bandeja de entrada, comprueba tu carpeta de correo no deseado.',
        payment_method: 'Forma de pago',
        tipalti_panel: 'Panel Tipalti',
        tipalti_payouts_incur_a_fee: 'Los pagos de Tipalti conllevan una comisión que puede ser de hasta 26 $. La comisión depende del método de pago seleccionado. A continuación encontrarás una tabla con la comisión de cada método de pago.',
        fee_per_payment: 'Tasa por pago',
        rejection_fee: 'Tasa de rechazo',
        echeck_local: 'eCheck (Local)',
        paypal_non_us: 'PayPal (No residente en EE.UU.)',
        paypal_us: 'PayPal (residente en EE.UU.)',
        wire_transfer_non_us_non_usd: 'Transferencia bancaria (no residente en EE.UU. pagado en dólares no estadounidenses)',
        wire_transfer_non_us_usd: 'Transferencia bancaria (los no residentes en EE.UU. pagan en USD)',
        wire_transfer_us: 'Transferencia bancaria (residente en EE.UU.)',
        up_to_21_usd: 'hasta 21,00',
        up_to_2_usd: 'hasta 2,00',
      },
      payoneer: 'Retirar con Payoneer',
      binance_pay: 'Retirar con Binance Pay',
      binancepay: 'Retirar con Binance Pay',
      p2p: 'Transferencia P2P',
      payouts_are_performed_on_a_rolling_basis: 'Los pagos se realizan de forma continua hasta 5 minutos después de ser solicitados.',
      your_payout_will_be_processed_at_the_current_rate: 'Tu pago se procesará a la tasa actual.',
      please_verify_the_wallet_address: 'Por favor, verifica la dirección del monedero. No podemos reembolsar una retirada incorrecta.',
      the_data_controller: 'El controlador de datos y parte contratante de Unlimint con respecto a los pagos procesados por ellos es Bitskins Sp. z o.o. con domicilio social en 40-246 Katowice, Porcelanowa str. 23, Polonia, registrada con el número: 0000810143 - puedes encontrar más detalles en Política de privacidad y ToS.',
      visa_withdrawals_are_processed_instantly: 'Las retiradas con VISA se procesan al instante. Sin embargo, en algunos casos pueden pasar varios días antes de que el dinero aparezca en tu cuenta bancaria.',
      card_info: 'Información de la tarjeta',
      ccv: 'CCV',
      add_new_deposit_needed: 'Añadir nuevo (depósito necesario)',
      you_can_have_max_3_bank_cards: 'Puedes tener un máximo de tres tarjetas bancarias asignadas a tu cuenta.',
      your_cards_amount: '<span class="text-cp">Tus</span> cartas ({x}/3)',
      the_minimum_withdraw_amount_is_x: 'El importe mínimo de retirada es {x}.',
      the_maximum_withdraw_amount_is_x: 'El importe máximo de retirada es {x}.',
      enter_amount: 'Introduce el importe',
      go_to_card_deposit: 'Ir al depósito de la tarjeta',
      to_be_able_to_withdraw_your_funds_you_need_to_verify_your_card: 'Para poder retirar tus fondos, primero tienes que verificar tu tarjeta. Puedes hacerlo depositando 1 $.',
      deposited_funds_are_non_withdrawable: 'Ten en cuenta que los fondos depositados no son retirables y sólo pueden utilizarse para compras.',
      we_do_not_support_mastercard_withdrawals: 'No admitimos reintegros a tarjetas MasterCard ni a tarjetas emitidas en los siguientes países: Bosnia y Herzegovina, Canadá, Egipto, Japón, Camboya, Corea (República de), KOSOVO, Macedonia del Norte, Estados Unidos de América, Argentina.',
      your_card_is_valid_until: 'Tu tarjeta es válida hasta el 16.02.2023, 15:35 (UTC). Transcurrido este plazo, tendrás que volver a verificar tu tarjeta depositando 5 $.',
      card_verification_required: '<span class="text-cp">Verificación de tarjeta</span> requerida',
      card: 'Tarjeta',
      add_new_card: '<span class="text-cp">Añadir nueva</span> tarjeta',
      how_to_find_my_binance_id: '¿Cómo encontrar mi ID de usuario (BUID) en Binance?',
      how_to_find_my_pay_id: '¿Cómo encontrar mi ID de usuario en Binance?',
      how_to_find_my_email: '¿Cómo encontrar mi correo electrónico en Binance?',
      binance_id: 'Binance ID',
      receiver_type: 'Tipo de receptor',
      i_do_not_have_a_binance_account: 'No tengo cuenta en Binance',
      i_have_a_binance_account: 'Tengo una cuenta Binance',
      binance_account: '<span class="text-cp">Cuenta Binance</span>',
      the_fee_is_already_included_in_the_current_x_rate: 'La tarifa {fee}% ya está incluida en la tarifa {x} actual.',
    },
    wallet: {
      transfer: 'Transferencia de fondos',
      refund: 'Devolución de fondos',
      available_payment_methods: 'Formas de pago disponibles',
      bank_cards: 'Tarjetas bancarias',
      kyc_required_for_this_payment_method: 'No puedes utilizar este método de pago porque no has pasado por el procedimiento KYC. Puedes iniciar el proceso de verificación ahora.',
      kyc_limit_exceeded: 'No puedes utilizar este método de pago porque has superado el límite de transacciones para tu nivel de CSC. Ahora puedes iniciar el proceso de verificación para eliminar las restricciones.',
      no_limit: 'Sin límite',
      limits_info: 'En Bitskins <strong>cada transacción tiene su propio temporizador y límite que se restablecen un año después de realizar la transacción</strong>. Las cantidades máximas que puedes depositar o retirar se muestran en los gráficos. Puedes aumentar los límites o eliminarlos completamente mediante el procedimiento KYC.',
      crypto_deposits: 'Depósitos de criptomonedas',
      crypto_withdrawals: 'Retiradas de criptomonedas',
      standard_deposits: 'Depósitos normales',
      standard_withdrawals: 'Retiradas normales',
      coupons_are_excluded_from_the_limit: '* los cupones están excluidos del límite',
      x_type_does_not_incur_any_fees: '{x} {type} no incurre en ningún gasto.',
      incur_fees_of: 'incurrir en tasas de',
      plus: ' más ',
      the_minimum_type_amount_is: 'La cantidad <span class="color-primary">mínima de {type}</span> es',
      the_maximum_type_amount_is: 'La cantidad <span class="color-primary">máxima {type}</span> es',
      due_to_unstable_crypto_network: 'Debido a la inestabilidad de la red criptográfica, puedes experimentar algunos retrasos.',
      binance_temporarily_disabled: 'Las retiradas de Binance están desactivadas hasta el lunes (28.08.2023)',
    },
  },
  enum: {
    report_type: {
      balance: 'Saldo',
      sell: 'Vendido',
      buy: 'Comprado',
    },
    report_status: {
      empty: 'Vacío',
      pending: 'Pendiente',
      done: 'Hecho',
    },
    autobump_period: {
      hour_1: '1h',
      hour_3: '3h',
      hour_6: '6h',
      hour_12: '12h',
      hour_24: '24h',
      hour_48: '48h',
    },
    autobump_status: {
      not_enough_bumps: 'No hay suficientes promociones',
      finished: 'Terminado',
      cancelled: 'Cancelado',
      pending: 'Pendiente',
      active: 'Activo',
    },
    inventory_status: {
      issue: 'Edición',
      not_available: 'No disponible',
      deleted: 'Suprimida',
      withdrawn: 'Retirada',
      delisted: 'Suprimida',
      ready: 'Listo',
      listed: 'Listado',
      listed_private: 'Listado privado',
      sold: 'Vendido',
      withdraw_queue: 'Retirar cola',
      withdraw_pending: 'Retirada pendiente',
      instant_sell: 'Venta instantánea',
    },
    service: {
      market: {
        buy: 'Comprar',
        sell: 'Vende',
        fee: 'Tasa de venta',
        buy_order: 'Orden de compra',
        bargain: 'Ganga',
        instant_sell: 'Venta instantánea',
        bump: 'Promoción',
        bump_package: 'Paquete de promoción',
      },
      deposit: {
        bitcoin: 'Depositar BTC',
        litecoin: 'Depósito LTC',
        ethereum: 'Depositar ETH',
        unlimint: 'Depósito con tarjeta bancaria',
        zen: 'Depósito con ZEN',
        gift_code: 'Código de regalo',
        binancepay: 'Depositar con Binance Pay',
      },
      withdraw: {
        bitcoin: 'Retirar BTC',
        litecoin: 'Retirar LTC',
        ethereum: 'Retirar ETH',
        unlimint: 'Retirar fondos a una tarjeta VISA',
        tipalti: 'Retirarse con Tipalti',
        payoneer: 'Retirar con Payoneer',
        binancepay: 'Retirar con Binance Pay',
        p2p: 'Transferencia P2P',
      },
      wallet: {
        transfer: 'Transferencia de fondos',
        refund: 'Devolución de fondos',
      },
      marketing: {
        coupon: 'Cupón',
        referral: 'Remisión',
        affiliate: 'Afíliate a',
      },
    },
  },
  meta: {
    default_title: 'BitSkins 2024',
    default_description: 'BitSkins ofrece una plataforma sin fisuras para comprar y vender tus artículos de CS2, DOTA2, TF2, RUST. Explora una amplia selección de rifles, cuchillos, guantes y mucho más. ¡Únete ahora para comerciar con facilidad!',
    home_title: 'BitSkins.com - Compra y Venta de Skins para CS2. Comercio rápido, fácil y seguro',
    home_description: 'BitSkins ofrece una plataforma sin fisuras para comprar y vender tus artículos de CS2, DOTA2, TF2, RUST. Explora una amplia selección de rifles, cuchillos, guantes y mucho más. ¡Únete ahora para comerciar con facilidad!',
    support_title: 'Soporte BitSkins: Obtén asistencia para tus necesidades de comercio con CS2',
    support_description: '¿Necesitas ayuda con tu operación CS2? Visita la página de soporte de BitSkins para obtener asistencia inmediata. Nuestro equipo está aquí para atender tus consultas, resolver problemas y proporcionarte orientación.',
    item_title: '{item} - {game} Skins | Encuentra e intercambia tus objetos {game} deseados',
    item_description_csgo: 'Descubre e intercambia las skins CS2 que desees en BitSkins. Explora nuestra amplia colección de rifles, cuchillos, guantes y mucho más. Compra, vende o retira al instante. ¡Empieza a navegar ahora!',
    item_description_cs2: 'Descubre e intercambia las skins CS2 que desees en BitSkins. Explora nuestra amplia colección de rifles, cuchillos, guantes y mucho más. Compra, vende o retira al instante. ¡Empieza a navegar ahora!',
    item_description_dota2: 'Descubre e intercambia las skins DOTA2 que desees en BitSkins. Explora nuestra amplia colección de guardas, músicas, paquetes y mucho más. Compra, vende o retira al instante. ¡Empieza a navegar ahora!',
    item_description_tf2: 'Descubre e intercambia los objetos de TF2 que desees en BitSkins. Explora nuestra amplia colección de cosméticos, burlas, cajas y mucho más. Compra, vende o retira al instante. ¡Empieza a buscar ahora!',
    item_description_rust: 'Descubre e intercambia los objetos RUST que desees en BitSkins. Explora nuestra amplia colección de ropa, armas, recursos y mucho más. Compra, vende o retira al instante. ¡Empieza a navegar ahora!',
    market_title: 'Mercado BitSkins: Explora e Intercambia Objetos {game} con Facilidad',
    market_description_csgo: 'Entra en el Mercado BitSkins para explorar e intercambiar una amplia gama de artículos de CS2 sin esfuerzo. Descubre las mejores ofertas en skins, llaves, cápsulas y mucho más. Compra, vende o retira al instante.',
    market_description_cs2: 'Entra en el Mercado BitSkins para explorar e intercambiar una amplia gama de artículos de CS2 sin esfuerzo. Descubre las mejores ofertas en skins, llaves, cápsulas y mucho más. Compra, vende o retira al instante.',
    market_description_dota2: 'Entra en el Mercado BitSkins para explorar e intercambiar una amplia gama de objetos DOTA2 sin esfuerzo. Descubre las mejores ofertas en salas, músicas, paquetes y mucho más. Compra, vende o retira al instante.',
    market_description_tf2: 'Entra en el Mercado BitSkins para explorar y comerciar con una amplia gama de objetos de TF2 sin esfuerzo. Descubre las mejores ofertas en cosméticos, burlas, cajas y mucho más. Compra, vende o retira al instante.',
    market_description_rust: 'Entra en el Mercado BitSkins para explorar y comerciar con una amplia gama de objetos RUST sin esfuerzo. Descubre las mejores ofertas en ropa, armas, recursos y mucho más. Compra, vende o retira al instante.',
    market_item_title: 'Mercado BitSkins: {skin} : {game} Mercado',
    store_title: 'Tienda de Usuario BitSkins: {alias} - {game} Escaparate de Artículos',
    store_description: 'Tienda de usuario de BitSkins para mostrar y vender tus artículos. Fija tus precios, interactúa con los compradores y establece tu presencia en la comunidad de comerciantes.',
    login_title: 'Inicio de sesión en BitSkins: Acceso seguro a tu cuenta de operaciones CS2',
    login_description: 'Accede a tu cuenta BitSkins de forma segura. Accede a tu inventario de CS2, gestiona artículos, realiza transacciones y disfruta de una experiencia comercial sin interrupciones.',
    steam_login_title: 'Iniciar sesión con Steam',
    profile_title: 'Configuración de tu cuenta',
    wallet_title: 'Tus fondos BitSkins',
    affiliate_title: 'Panel de Afiliados de BitSkins: Gana recompensas por referidos',
    affiliate_description: 'Únete al programa de afiliados de BitSkins y gana recompensas recomendando a entusiastas de la piel. Benefíciate de un lucrativo programa de afiliados, haz un seguimiento de tus recomendaciones y maximiza tus ganancias.',
    statistics_title: 'Estadísticas de ventas de BitSkins: Descubre las tendencias y perspectivas del mercado',
    statistics_description: 'Explora las estadísticas completas de BitSkins para obtener información valiosa sobre las tendencias comerciales de CS2. Analiza los datos del mercado, la popularidad de los artículos y mucho más para optimizar tus estrategias de negociación.',
    sales_fees_title: 'Tarifas de venta de BitSkins: Precios transparentes para tus ventas de CS2',
    sales_fees_description: 'Comprende claramente la estructura de tarifas de venta de BitSkins. Nuestras tarifas transparentes garantizan la equidad y simplicidad de tus ventas de CS2. Más información.',
    checkout_title: 'Cesta BitSkins: Pago cómodo para artículos CS2',
    checkout_description: 'Simplifica tu experiencia de compra en CS2 con el Carrito BitSkins. Gestiona fácilmente tus artículos, revisa tu pedido y procede a un pago seguro. ¡Disfruta hoy mismo de un proceso de compraventa sin problemas!',
    steam_inventory_title: 'Mi {game} Inventario de Steam',
    bs_inventory_title: 'Mi {game} Inventario de BitSkins',
    selling_inventory_title: 'Mi {game} Artículos listados',
    buy_order_create_title: 'Crear órdenes de compra para {game}',
    buy_order_active_title: 'Órdenes de compra activas para {game}',
    buy_order_title: 'Órdenes de compra para {game}',
    trades_active_title: 'Operaciones activas',
    trades_history_title: 'Historial comercial',
    transactions_title: 'Transacciones',
    favorites_title: 'Artículos favoritos',
    kyc_title: 'Formulario de solicitud "Conoce a tu cliente" (KYC)',
    tos_title: 'Condiciones de uso de BitSkins: Directrices para un comercio seguro y de confianza',
    tos_description: 'Revisa nuestras Condiciones de uso para operar con seguridad y confianza. Familiarízate con nuestras políticas y obligaciones. Comercia con seguridad en BitSkins.',
    privacy_policy_title: 'Política de privacidad de BitSkins: Protección de tus datos personales',
    privacy_policy_description: 'Lee la Política de privacidad de BitSkins para saber cómo protegemos y tratamos tu información personal. La confianza y la transparencia son el núcleo de nuestro compromiso.',
    cookie_policy_title: 'Política de Cookies de BitSkins: Tu privacidad nos importa',
    cookie_policy_description: 'En BitSkins, valoramos tu privacidad. Lee nuestra Política de Cookies para entender cómo utilizamos las cookies y tecnologías similares. Tu confianza y la seguridad de tus datos son nuestras principales prioridades.',
    docs_v1_title: 'API BitSkins V1: Versión heredada de la API',
    docs_v1_description: 'Integra la API V1 de BitSkins para operar sin problemas. Accede a la documentación para optimizar tus capacidades de negociación. Actualiza a la última versión para obtener nuevas funciones.',
    docs_v2_title: 'API BitSkins V2: La versión más reciente de la API',
    docs_v2_description: 'Desbloquea nuevas funciones con la API V2 de BitSkins. Mejora tus estrategias de negociación y tu eficacia. ¡Explora ahora nuestra completa documentación!',
    docs_migration_title: 'Migración a la API de BitSkins: Transición sin problemas a la nueva API',
    docs_migration_description: 'Migra sin problemas a la nueva API de BitSkins con nuestra guía completa. Explora las funciones actualizadas y los procesos de integración para una experiencia de negociación mejorada.',
  },
  alt: {
    envelope: 'Sobre',
    app_store: 'App Store',
    google_store: 'Tienda Google',
  },
  time: {
    seconds: 'segundos',
  },
  calendar: {
    week: 'Semana',
    month: 'Mes',
    lifetime: 'Para toda la vida',
  },
  docs: {
    docs: 'Docs',
    api: 'API',
    api_v1: 'API V1 (Pasarela)',
    api_v2: 'API V2',
    api_migration_guide: 'Guía de migración de la API',
    request_parameters: 'Parámetros de la solicitud',
    sample_request: 'Solicitud de muestras',
    sample_response: 'Muestra de respuesta',
    request_schema: 'Solicitar esquema',
    enums: 'ENUMS',
  },
  wallet: {
    coupon_redeemed: 'Has canjeado un cupón de {amount}.',
    balance_changed: 'Se ha actualizado el saldo',
    transfer_p2p_confirm: 'Confirma la transferencia de fondos a p2p.bitskins.com',
    transfer_p2p_confirm_needed: 'Tienes que confirmar la transferencia',
    transfer_p2p_success: 'Tus fondos han sido transferidos a p2p.bitskins.com',
    transfer_funds: 'Transferir fondos',
    deposit_started: 'Depósito iniciado',
    card_removed: 'Tarjeta retirada',
    confirm_card_remove: '¿Estás seguro de que quieres eliminar esta tarjeta?',
    delete_card: 'Borrar tarjeta',
    deposit: 'depósito',
    withdraw: 'retirar',
    security_code: 'Código de seguridad',
    security_code_ccv: 'Código de seguridad',
    card_number: 'Número de tarjeta',
    full_name: 'Nombre y apellidos',
    month_expired: 'Mes de vencimiento (MM/AAAA)',
    addr_line_1: 'Dirección de facturación (línea 1)',
    addr_line_2: 'Dirección de facturación (línea 2)',
    zip: 'Código postal',
    city: 'Ciudad',
    country: 'País',
    withdraw_only_to_visa: 'Sólo puedes retirar fondos a una tarjeta Visa',
    card_country_is_restricted: 'Lamentablemente, no proporcionamos reintegros a tarjetas emitidas en {country}.',
  },
  twofa: {
    required: 'Se requiere autenticación de dos factores',
    required_for_this_payment_method: 'No puedes utilizar este método de pago porque no has configurado la autenticación de dos factores.',
    you_can_start_now: 'Ya puedes iniciar el proceso de configuración.',
    setup: 'Configurar 2FA',
    why_we_require: 'Haz clic para leer - ¿Por qué exigimos 2FA para las retiradas?',
  },
  password_strong: {
    minimum: 'La contraseña debe tener al menos {value} caracteres',
    maximum: 'La contraseña debe tener como máximo {value} caracteres de longitud',
    lowercase: 'La contraseña debe tener al menos 1 carácter en minúscula',
    uppercase: 'La contraseña debe tener al menos 1 carácter en mayúscula',
    numeric: 'La contraseña debe tener al menos 1 carácter numérico',
    special: 'La contraseña debe tener al menos 1 carácter especial',
  },
  help_center: {
    help_center: 'Centro de ayuda',
    hello: 'Hola, ¿cómo podemos ayudarte?',
    create_ticket: 'Crear un ticket',
    contact_us: 'Contáctanos',
    guide: 'Guía ',
    top_articles: 'Preguntas frecuentes',
    didnt_find: '¿No encontraste lo que buscabas?',
    article: 'Articles',
    general: 'General',
    fees: 'Tasas',
    buying_selling: 'Compra Venta',
    deposit_withdrawal: 'Depositar y Retirar',
    refunds: 'Devoluciones',
    user_account: 'Cuenta',
    affiliate: 'Afiliado',
    partnership: 'Asociación',
    scam: 'Posible estafa ',
    was_helpful: '¿Te resultó de ayuda este artículo?',
    found_helpful: '{yes} de {max} encontró esto útil',
    faq: 'Preguntas frecuentes',
  },
};
